//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { FileParameter, FileResponse } from '../../models/file-models';
import { columnMap } from '../../../shared/table/models/column-map.decorator';
import { keyMap } from '../../../shared/table/models/key-map.decorator';
import {
    ApiActivity,
    IApiActivity,
    ApiNamedListItem,
    ApiIdNameItem,
    IApiIdNameItem,
    ApiMemberInfo,
    ApiNote,
    IApiNote,
    ApiFileInfo,
    IApiFileInfo,
    ApiListItemPosition,
    ApiRange,
    ApiText,
    IApiMemberInfo,
    ApiCreateMemberRequest,
    ApiDateRange,
    ApiNoteListItem,
    BackgroundProcessEnum,
    BackgroundProcessStatusEnum,
    BackgroundProcessStepStatus,
    NoteTypeEnum,
    SocialNetworkEnum,
    FileUploadErrorEnum,
    ApiExternalAccountInfo,
    Module,
    Permission,
    ServicesEnum,
    ApiCreatorInfo,
    FileValidationModel,
    TimerTaskType,
    Gender
} from './open-api-clients';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiAccountReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiAccountReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiAccountReasonListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiAccountReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiAccountReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(apiModel: ApiAccountReasonUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    checkNotExist(query: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/check-not-exist?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNotExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNotExist(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckNotExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiModel: ApiAccountReasonUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiAccountReasonDetails> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAccountReasonDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAccountReasonDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiAccountReasonDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAccountReasonDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMemberReasonUsageList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiMemberReasonUsageListItem> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}/members-usage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberReasonUsageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberReasonUsageList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiMemberReasonUsageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiMemberReasonUsageListItem>;
        }));
    }

    protected processGetMemberReasonUsageList(response: HttpResponseBase): Observable<ApiPageResultOfApiMemberReasonUsageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiMemberReasonUsageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getOrganizationReasonUsageList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiOrganizationReasonUsageListItem> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}/organizations-usage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationReasonUsageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationReasonUsageList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiOrganizationReasonUsageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiOrganizationReasonUsageListItem>;
        }));
    }

    protected processGetOrganizationReasonUsageList(response: HttpResponseBase): Observable<ApiPageResultOfApiOrganizationReasonUsageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiOrganizationReasonUsageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getGroupReasonUsageList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiGroupReasonUsageListItem> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}/groups-usage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupReasonUsageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupReasonUsageList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiGroupReasonUsageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiGroupReasonUsageListItem>;
        }));
    }

    protected processGetGroupReasonUsageList(response: HttpResponseBase): Observable<ApiPageResultOfApiGroupReasonUsageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiGroupReasonUsageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReasons(type: AccountReasonTypeEnum | undefined): Observable<ApiAccountReasonDropdownItem[]> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/reasons-by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAccountReasonDropdownItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAccountReasonDropdownItem[]>;
        }));
    }

    protected processGetReasons(response: HttpResponseBase): Observable<ApiAccountReasonDropdownItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAccountReasonDropdownItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReasonUsageDetails(id: number): Observable<ApiAccountReasonUsageDetails> {
        let url_ = this.baseUrl + "/api/accounts/settings/reasons/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAccountReasonUsageDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAccountReasonUsageDetails>;
        }));
    }

    protected processGetReasonUsageDetails(response: HttpResponseBase): Observable<ApiAccountReasonUsageDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAccountReasonUsageDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getPermissionsToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/accounts/permissions/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsToken(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string>;
        }));
    }

    protected processGetPermissionsToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(roleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiRoleMemberListItem> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/members?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiRoleMemberListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiRoleMemberListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiRoleMemberListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiRoleMemberListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addMembersToRole(roleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/members";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMembersToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMembersToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddMembersToRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeMembersFromRole(roleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/members";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMembersFromRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMembersFromRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveMembersFromRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findMembersNotInRole(roleId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/members/not-in-role?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindMembersNotInRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindMembersNotInRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindMembersNotInRole(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RolePermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getRolePermissions(roleId: number): Observable<ApiServicePermissions[]> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiServicePermissions[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiServicePermissions[]>;
        }));
    }

    protected processGetRolePermissions(response: HttpResponseBase): Observable<ApiServicePermissions[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiServicePermissions.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateRolePermissions(roleId: number, apiModels: ApiModulePermissions[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRolePermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiRoleListItem> {
        let url_ = this.baseUrl + "/api/accounts/roles?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiRoleListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiRoleListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiRoleListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiRoleListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createRole(model: ApiRole): Observable<ApiRole> {
        let url_ = this.baseUrl + "/api/accounts/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRole>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRole>;
        }));
    }

    protected processCreateRole(response: HttpResponseBase): Observable<ApiRole> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAllRoleNames(): Observable<ApiRoleName[]> {
        let url_ = this.baseUrl + "/api/accounts/roles/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoleNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoleNames(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRoleName[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRoleName[]>;
        }));
    }

    protected processGetAllRoleNames(response: HttpResponseBase): Observable<ApiRoleName[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiRoleName.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getInternalRoleNames(): Observable<ApiRoleName[]> {
        let url_ = this.baseUrl + "/api/accounts/roles/internal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalRoleNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalRoleNames(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRoleName[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRoleName[]>;
        }));
    }

    protected processGetInternalRoleNames(response: HttpResponseBase): Observable<ApiRoleName[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiRoleName.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getRole(id: number): Observable<ApiRole> {
        let url_ = this.baseUrl + "/api/accounts/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRole>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRole>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<ApiRole> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateRole(id: number, model: ApiRole): Observable<ApiRole> {
        let url_ = this.baseUrl + "/api/accounts/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRole>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRole>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<ApiRole> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isNameInUse(roleName: string | null | undefined, roleId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/roles/is-name-in-use?";
        if (roleName !== undefined && roleName !== null)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNameInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNameInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsNameInUse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationAvatarsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAvatar(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadAvatarUrl(id: number, avatar: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/accounts/organizations/{id}/avatar";
                        if (id === undefined || id === null)
                            throw new Error("The parameter 'id' must be defined.");
                        url_ = url_.replace("{id}", encodeURIComponent("" + id));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadAvatar(id: number, avatar: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (avatar !== null && avatar !== undefined)
            content_.append("avatar", avatar.data, avatar.fileName ? avatar.fileName : "avatar");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteAvatar(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiOrganizationGroupListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/groups?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiOrganizationGroupListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiOrganizationGroupListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiOrganizationGroupListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiOrganizationGroupListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number): Observable<ApiOrganization> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganization>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganization>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiOrganization> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiOrganizationListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiOrganizationListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiOrganizationListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiOrganizationListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiOrganizationListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createNew(createRequest: ApiOrganizationCreateRequest): Observable<ApiOrganization> {
        let url_ = this.baseUrl + "/api/accounts/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganization>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganization>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<ApiOrganization> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    export(odataQuery: string | undefined, definition: ExportDefinition): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/organizations/export?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    canMakePublic(id: number): Observable<MakePublicErrorsEnum[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/can-make-public";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanMakePublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanMakePublic(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<MakePublicErrorsEnum[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<MakePublicErrorsEnum[]>;
        }));
    }

    protected processCanMakePublic(response: HttpResponseBase): Observable<MakePublicErrorsEnum[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    makePublic(id: number, relatedMembersIdsToNotify: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/make-public";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(relatedMembersIdsToNotify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakePublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakePublic(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processMakePublic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findAvailableMembers(query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/available-members?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deactivate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    activate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getMain(organizationId: number): Observable<ApiOrganizationAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses/main";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMain(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationAddressDetails>;
        }));
    }

    protected processGetMain(response: HttpResponseBase): Observable<ApiOrganizationAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDelivery(organizationId: number): Observable<ApiOrganizationAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses/delivery";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationAddressDetails>;
        }));
    }

    protected processGetDelivery(response: HttpResponseBase): Observable<ApiOrganizationAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getBillingAddress(organizationId: number): Observable<ApiOrganizationAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses/billing";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationAddressDetails>;
        }));
    }

    protected processGetBillingAddress(response: HttpResponseBase): Observable<ApiOrganizationAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getShippingAddress(organizationId: number): Observable<ApiOrganizationAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses/shipping";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationAddressDetails>;
        }));
    }

    protected processGetShippingAddress(response: HttpResponseBase): Observable<ApiOrganizationAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(organizationId: number, apiModel: ApiAccountAddress): Observable<ApiOrganizationAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationAddressDetails>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiOrganizationAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(organizationId: number, apiModel: ApiAccountAddress): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/addresses";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationAttachmentNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(organizationId: number, attachmentId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}/notes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(organizationId: number, attachmentId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}/notes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(organizationId: number, attachmentId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(organizationId: number, attachmentId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationAttachmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiAttachmentListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiAttachmentListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiAttachmentListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiAttachmentListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiAttachmentListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createUrl(organizationId: number, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments";
                        if (organizationId === undefined || organizationId === null)
                            throw new Error("The parameter 'organizationId' must be defined.");
                        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    create(organizationId: number, files: FileParameter[] | null | undefined): Observable<ApiAttachmentListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAttachmentListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAttachmentListItem[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiAttachmentListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAttachmentListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(organizationId: number, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(organizationId: number, attachmentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/attachments/{attachmentId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/accounts/organizations/attachments/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(organizationId: number): Observable<ApiOrganizationDetails> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/details";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiOrganizationDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(organizationId: number, apiModel: ApiOrganizationDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/details";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationGeneralClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getOrganizationHead(organizationId: number): Observable<ApiOrganizationHead> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/head";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationHead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationHead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationHead>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationHead>;
        }));
    }

    protected processGetOrganizationHead(response: HttpResponseBase): Observable<ApiOrganizationHead> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationHead.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrganizationHead(organizationId: number, apiModel: ApiOrganizationHead): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/head";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationHead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationHead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrganizationHead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(organizationId: number): Observable<ApiOrganizationActivity> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/activity";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiOrganizationActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHeader(organizationId: number): Observable<ApiOrganizationHeader> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/profile/general/header";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiOrganizationHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiNoteListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/notes?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiNoteListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(organizationId: number, newNote: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/notes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(organizationId: number, noteId: number, newNote: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(organizationId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationReasonNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(organizationId: number, reasonId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons/{reasonId}/notes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(organizationId: number, reasonId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons/{reasonId}/notes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(organizationId: number, reasonId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons/{reasonId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(organizationId: number, reasonId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons/{reasonId}/notes/{noteId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getLastReason(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/reasons/last-reason?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReason(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetLastReason(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationRelatedMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAll(organizationId: number): Observable<ApiOrganizationRelatedMember[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/all";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationRelatedMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationRelatedMember[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiOrganizationRelatedMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiOrganizationRelatedMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiOrganizationRelatedMemberListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/list?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiOrganizationRelatedMemberListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiOrganizationRelatedMemberListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiOrganizationRelatedMemberListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiOrganizationRelatedMemberListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(organizationId: number, memberId: number): Observable<ApiOrganizationRelatedMember> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/{memberId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationRelatedMember>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationRelatedMember>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiOrganizationRelatedMember> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationRelatedMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(organizationId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/{memberId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createNew(organizationId: number, request: ApiOrganizationRelatedMemberCreateRequest): Observable<ApiOrganizationRelatedMember[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationRelatedMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationRelatedMember[]>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<ApiOrganizationRelatedMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiOrganizationRelatedMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    sendApprovalEmail(organizationId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/{memberId}/send-approval-email";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendApprovalEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendApprovalEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSendApprovalEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    approveRelation(token: string): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/related-members/approve-relation/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processApproveRelation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    changeRelatedMemberType(organizationId: number, memberId: number, newType: OrganizationRelatedMemberTypeEnum | undefined): Observable<ApiOrganizationRelatedMember> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/{memberId}/change-type?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (newType === null)
            throw new Error("The parameter 'newType' cannot be null.");
        else if (newType !== undefined)
            url_ += "newType=" + encodeURIComponent("" + newType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRelatedMemberType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRelatedMemberType(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOrganizationRelatedMember>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOrganizationRelatedMember>;
        }));
    }

    protected processChangeRelatedMemberType(response: HttpResponseBase): Observable<ApiOrganizationRelatedMember> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOrganizationRelatedMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findNotRelatedMembers(organizationId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/related-members/not-related-members?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindNotRelatedMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindNotRelatedMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindNotRelatedMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getEmailList(organizationId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEmailSettingsListItem> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/emails?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEmailSettingsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEmailSettingsListItem>;
        }));
    }

    protected processGetEmailList(response: HttpResponseBase): Observable<ApiPageResultOfApiEmailSettingsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEmailSettingsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addEmail(organizationId: number, apiModel: ApiAddEmail): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/add-email";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    moveEmailToUsed(organizationId: number, emailId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/move-email-to-used/{emailId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEmailToUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEmailToUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processMoveEmailToUsed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isEmailNotUsed(organizationId: number, email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/email-not-used?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmailNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    sendEmailConfirmation(organizationId: number, email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/confirm-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    confirmEmail(token: string): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/organizations/settings/confirm-email/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    canAddEmail(organizationId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/organizations/{organizationId}/settings/can-add-email";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanAddEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanAddEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCanAddEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getBillingAddress(memberId: number): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/addresses/billing";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processGetBillingAddress(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getShippingAddress(memberId: number): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/addresses/shipping";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processGetShippingAddress(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addOrUpdate(memberId: number, address: ApiAccountAddress): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/addresses";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberAffiliationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAffiliate(memberId: number): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/affiliations";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffiliate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffiliate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processGetAffiliate(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(memberId: number, apiModel: ApiAccountAddress): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/affiliations";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(memberId: number, apiModel: ApiAccountAddress): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/affiliations";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberAvatarsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAvatar(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadAvatarUrl(id: number, avatar: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/accounts/members/{id}/avatar";
                        if (id === undefined || id === null)
                            throw new Error("The parameter 'id' must be defined.");
                        url_ = url_.replace("{id}", encodeURIComponent("" + id));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadAvatar(id: number, avatar: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (avatar !== null && avatar !== undefined)
            content_.append("avatar", avatar.data, avatar.fileName ? avatar.fileName : "avatar");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteAvatar(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/avatar";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberRegistrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    registerInternal(apiRegisterMemberModel: ApiRegisterUserModel): Observable<ApiMemberRegistrationResult> {
        let url_ = this.baseUrl + "/api/accounts/registration/internal-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiRegisterMemberModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInternal(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberRegistrationResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberRegistrationResult>;
        }));
    }

    protected processRegisterInternal(response: HttpResponseBase): Observable<ApiMemberRegistrationResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberRegistrationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    registerInternalFromDialog(model: ApiCreateMemberRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/registration/internal-member-from-dialog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInternalFromDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInternalFromDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processRegisterInternalFromDialog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    requestResetPassword(emailModel: ApiEmailModel): Observable<ApiForgotPasswordResponse> {
        let url_ = this.baseUrl + "/api/accounts/registration/request-reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiForgotPasswordResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiForgotPasswordResponse>;
        }));
    }

    protected processRequestResetPassword(response: HttpResponseBase): Observable<ApiForgotPasswordResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiForgotPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPasswordChangeDate(memberId: number): Observable<ApiPasswordChangeDate> {
        let url_ = this.baseUrl + "/api/accounts/registration/{memberId}/password-change-date";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordChangeDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordChangeDate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPasswordChangeDate>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPasswordChangeDate>;
        }));
    }

    protected processGetPasswordChangeDate(response: HttpResponseBase): Observable<ApiPasswordChangeDate> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPasswordChangeDate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isEmailNotUsed(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/registration/email-not-used?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmailNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberRolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInternalMemberRoles(memberId: number): Observable<ApiMemberRole[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/roles";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMemberRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMemberRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberRole[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberRole[]>;
        }));
    }

    protected processGetInternalMemberRoles(response: HttpResponseBase): Observable<ApiMemberRole[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberRole.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateRoles(memberId: number, roles: string[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/roles";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string[]>;
        }));
    }

    protected processUpdateRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiMemberListItem> {
        let url_ = this.baseUrl + "/api/accounts/members?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiMemberListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiMemberListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiMemberListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiMemberListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    export(odataQuery: string | undefined, definition: ExportDefinition): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/members/export?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiMember> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMember>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMember>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiMember> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getByEmail(primaryEmail: string): Observable<ApiMember> {
        let url_ = this.baseUrl + "/api/accounts/members/{primaryEmail}";
        if (primaryEmail === undefined || primaryEmail === null)
            throw new Error("The parameter 'primaryEmail' must be defined.");
        url_ = url_.replace("{primaryEmail}", encodeURIComponent("" + primaryEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMember>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMember>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<ApiMember> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getInfo(id: number): Observable<ApiMemberInfo> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiMemberInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deactivate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    activate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findMembers(query: string | null | undefined, excludedRole: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/members/find?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludedRole !== undefined && excludedRole !== null)
            url_ += "excludedRole=" + encodeURIComponent("" + excludedRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberAttachmentNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(memberId: number, attachmentId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}/notes";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(memberId: number, attachmentId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}/notes";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(memberId: number, attachmentId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(memberId: number, attachmentId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberAttachmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiAttachmentListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiAttachmentListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiAttachmentListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiAttachmentListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiAttachmentListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createUrl(memberId: number, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments";
                        if (memberId === undefined || memberId === null)
                            throw new Error("The parameter 'memberId' must be defined.");
                        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    create(memberId: number, files: FileParameter[] | null | undefined): Observable<ApiAttachmentListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAttachmentListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAttachmentListItem[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiAttachmentListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAttachmentListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(memberId: number, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(memberId: number, attachmentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/attachments/{attachmentId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberGeneralTabClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getMemberDetails(memberId: number): Observable<ApiMemberDetails> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberDetails>;
        }));
    }

    protected processGetMemberDetails(response: HttpResponseBase): Observable<ApiMemberDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateMemberDetails(memberId: number, apiModel: ApiMemberDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMemberDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMemberDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMemberDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMembershipOrganizationList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiOrganizationMembershipListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general/membership-organization?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembershipOrganizationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembershipOrganizationList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiOrganizationMembershipListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiOrganizationMembershipListItem>;
        }));
    }

    protected processGetMembershipOrganizationList(response: HttpResponseBase): Observable<ApiPageResultOfApiOrganizationMembershipListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiOrganizationMembershipListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(memberId: number): Observable<ApiMemberActivity> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general/activity";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiMemberActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isMemberOrcidIdUnused(memberId: number, orcidId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general/is-orcid-id-unused?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (orcidId !== undefined && orcidId !== null)
            url_ += "orcidId=" + encodeURIComponent("" + orcidId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMemberOrcidIdUnused(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMemberOrcidIdUnused(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsMemberOrcidIdUnused(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateSocialProfiles(memberId: number, apiModel: ApiMemberSocialProfiles): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/profile/general/social-profiles";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSocialProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSocialProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSocialProfiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiNoteListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/notes?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiNoteListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(memberId: number, newNote: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/notes";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(memberId: number, noteId: number, newNote: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(memberId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberReasonNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(memberId: number, reasonId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons/{reasonId}/notes";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(memberId: number, reasonId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons/{reasonId}/notes";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(memberId: number, reasonId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons/{reasonId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(memberId: number, reasonId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons/{reasonId}/notes/{noteId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getLastReason(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/reasons/last-reason?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReason(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetLastReason(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getEmailList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEmailSettingsListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEmailSettingsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEmailSettingsListItem>;
        }));
    }

    protected processGetEmailList(response: HttpResponseBase): Observable<ApiPageResultOfApiEmailSettingsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEmailSettingsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addEmail(memberId: number, apiModel: ApiAddEmail): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAuthorEmailList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiAuthorEmailListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/author-emails?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorEmailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorEmailList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiAuthorEmailListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiAuthorEmailListItem>;
        }));
    }

    protected processGetAuthorEmailList(response: HttpResponseBase): Observable<ApiPageResultOfApiAuthorEmailListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiAuthorEmailListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isMemberAuthor(memberId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/is-author";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMemberAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMemberAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsMemberAuthor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    moveEmailToUsed(memberId: number, emailId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails/{emailId}/move-email-to-used";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEmailToUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEmailToUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processMoveEmailToUsed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableEmailTypes(memberId: number): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails/available-types";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableEmailTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableEmailTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetAvailableEmailTypes(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    canAddEmail(memberId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails/can-add";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanAddEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanAddEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCanAddEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isEmailNotUsed(memberId: number, type: EmailTypeEnum | undefined, email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails/is-not-used?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmailNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    sendEmailConfirmation(memberId: number, emailId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/settings/emails/{emailId}/send-email-confirmation";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountMembershipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAccountMembership(memberId: number): Observable<ApiMemberAccountMembership> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/account";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAccountMembership>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAccountMembership>;
        }));
    }

    protected processGetAccountMembership(response: HttpResponseBase): Observable<ApiMemberAccountMembership> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAccountMembership.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalResponsibilitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiJournalResponsibilityListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/journal-responsibilities?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiJournalResponsibilityListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiJournalResponsibilityListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiJournalResponsibilityListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiJournalResponsibilityListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(memberId: number, apiModel: ApiJournalResponsibilities): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/journal-responsibilities";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(memberId: number, apiModel: ApiJournalResponsibility): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/journal-responsibilities";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getJournalList(memberId: number, query: string | null | undefined, responsibilityIdList: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/journal-responsibilities/journal-list?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (responsibilityIdList !== undefined && responsibilityIdList !== null)
            responsibilityIdList && responsibilityIdList.forEach(item => { url_ += "responsibilityIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJournalList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetJournalList(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getResponsibilityList(memberId: number, query: string | null | undefined, journalIdList: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/membership/journal-responsibilities/responsibility-list?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (journalIdList !== undefined && journalIdList !== null)
            journalIdList && journalIdList.forEach(item => { url_ += "journalIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsibilityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsibilityList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetResponsibilityList(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiMemberGroupListItem> {
        let url_ = this.baseUrl + "/api/accounts/members/{memberId}/groups?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiMemberGroupListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiMemberGroupListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiMemberGroupListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiMemberGroupListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(groupId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiGroupMemberListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiGroupMemberListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiGroupMemberListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiGroupMemberListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiGroupMemberListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addMembersToGroup(groupId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMembersToGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMembersToGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddMembersToGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    export(groupId: number, odataQuery: string | undefined, definition: ExportDefinition): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/export?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAdminList(groupId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiGroupAdminListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/admins?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiGroupAdminListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiGroupAdminListItem>;
        }));
    }

    protected processGetAdminList(response: HttpResponseBase): Observable<ApiPageResultOfApiGroupAdminListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiGroupAdminListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findNotAdmins(groupId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/in-group?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindNotAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindNotAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindNotAdmins(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findMembersNotInGroup(groupId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/not-in-group?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindMembersNotInGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindMembersNotInGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processFindMembersNotInGroup(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeMemberFromGroup(groupId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/{memberId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMemberFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMemberFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveMemberFromGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addAdmins(groupId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/add-admins";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddAdmins(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeAdmin(groupId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/{memberId}/remove-admin";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAdminInfo(groupId: number): Observable<ApiGroupAdminInfo> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/admin-info";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroupAdminInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroupAdminInfo>;
        }));
    }

    protected processGetAdminInfo(response: HttpResponseBase): Observable<ApiGroupAdminInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroupAdminInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAdminInfo(groupId: number, model: ApiGroupAdminInfo): Observable<ApiGroupAdminInfo> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/members/admin-info";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdminInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdminInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroupAdminInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroupAdminInfo>;
        }));
    }

    protected processUpdateAdminInfo(response: HttpResponseBase): Observable<ApiGroupAdminInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroupAdminInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupOrganizationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(groupId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiGroupOrganizationListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/organizations?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiGroupOrganizationListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiGroupOrganizationListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiGroupOrganizationListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiGroupOrganizationListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addOrganizationsToGroup(groupId: number, organizationIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/organizations";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrganizationsToGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrganizationsToGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddOrganizationsToGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    export(groupId: number, odataQuery: string | undefined, definition: ExportDefinition): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/organizations/export?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findOrganizationsNotInGroup(groupId: number, query: string | null | undefined): Observable<ApiShortOrganizationInfo[]> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/organizations/not-in-group?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindOrganizationsNotInGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindOrganizationsNotInGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiShortOrganizationInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiShortOrganizationInfo[]>;
        }));
    }

    protected processFindOrganizationsNotInGroup(response: HttpResponseBase): Observable<ApiShortOrganizationInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiShortOrganizationInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeOrganizationFromGroup(groupId: number, organizationId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/organizations/{organizationId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrganizationFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrganizationFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveOrganizationFromGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number): Observable<ApiGroup> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroup>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroup>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiGroup> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiGroupListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiGroupListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiGroupListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiGroupListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiGroupListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createNew(groupModel: ApiGroup): Observable<ApiGroup> {
        let url_ = this.baseUrl + "/api/accounts/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroup>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroup>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<ApiGroup> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isGroupNameAvailable(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/accounts/groups/is-name-available?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsGroupNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsGroupNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsGroupNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findGroups(query: string | null | undefined, excludeGroupsWithOrganizations: boolean | undefined, entityId: number | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/groups/find?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeGroupsWithOrganizations === null)
            throw new Error("The parameter 'excludeGroupsWithOrganizations' cannot be null.");
        else if (excludeGroupsWithOrganizations !== undefined)
            url_ += "excludeGroupsWithOrganizations=" + encodeURIComponent("" + excludeGroupsWithOrganizations) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processFindGroups(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addMembers(odataQuery: string | undefined, requestModel: ApiGroupAddMembersRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/add-members?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddMembers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addOrganizations(odataQuery: string | undefined, requestModel: ApiGroupAddOrganizationsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/add-organizations?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddOrganizations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(id: number): Observable<ApiGroupActivity> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}/activity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroupActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroupActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiGroupActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroupActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getGroupDetails(id: number): Observable<ApiGroupDetails> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGroupDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGroupDetails>;
        }));
    }

    protected processGetGroupDetails(response: HttpResponseBase): Observable<ApiGroupDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiGroupDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateGroupDetails(id: number, apiModel: ApiGroupDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateGroupDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deactivate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    activate(id: number, apiModel: ApiActivateDeactivate): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupReasonNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(groupId: number, reasonId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons/{reasonId}/notes";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(groupId: number, reasonId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons/{reasonId}/notes";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(groupId: number, reasonId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons/{reasonId}/notes/{noteId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(groupId: number, reasonId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons/{reasonId}/notes/{noteId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(groupId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getLastReason(groupId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiReasonListItem> {
        let url_ = this.baseUrl + "/api/accounts/groups/{groupId}/reasons/last-reason?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReason(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiReasonListItem>;
        }));
    }

    protected processGetLastReason(response: HttpResponseBase): Observable<ApiPageResultOfApiReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ApiPageResultOfApiAccountReasonListItem implements IApiPageResultOfApiAccountReasonListItem {
    items?: ApiAccountReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiAccountReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiAccountReasonListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiAccountReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiAccountReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiAccountReasonListItem {
    items?: ApiAccountReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export abstract class ApiBaseReasonListItem implements IApiBaseReasonListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    reasonValue?: string | null;
    @columnMap(() => Number)
    usageCount?: number;

    constructor(data?: IApiBaseReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reasonValue = _data["reasonValue"] !== undefined ? _data["reasonValue"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonListItem {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReasonListItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reasonValue"] = this.reasonValue !== undefined ? this.reasonValue : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        return data;
    }
}

export interface IApiBaseReasonListItem {
    id?: number;
    reasonValue?: string | null;
    usageCount?: number;
}

export class ApiAccountReasonListItem extends ApiBaseReasonListItem implements IApiAccountReasonListItem {
    @columnMap(() => AccountReasonTypeEnum)
    type?: AccountReasonTypeEnum;

    constructor(data?: IApiAccountReasonListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiAccountReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountReasonListItem extends IApiBaseReasonListItem {
    type?: AccountReasonTypeEnum;
}

export enum AccountReasonTypeEnum {
    AddIPToBlacklist = 0,
    DeactivateIPAddress = 1,
    DeactivateMember = 2,
    ActivateMember = 3,
    DeactivateOrganization = 4,
    ActivateOrganization = 5,
    DeactivateGroup = 6,
    ActivateGroup = 7,
}

export abstract class ApiBaseReasonUpdate implements IApiBaseReasonUpdate {
    reasonValue: string;

    constructor(data?: IApiBaseReasonUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonValue = _data["reasonValue"] !== undefined ? _data["reasonValue"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonUpdate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReasonUpdate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonValue"] = this.reasonValue !== undefined ? this.reasonValue : null as any;
        return data;
    }
}

export interface IApiBaseReasonUpdate {
    reasonValue: string;
}

export class ApiAccountReasonUpdate extends ApiBaseReasonUpdate implements IApiAccountReasonUpdate {
    type?: AccountReasonTypeEnum;

    constructor(data?: IApiAccountReasonUpdate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiAccountReasonUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountReasonUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountReasonUpdate extends IApiBaseReasonUpdate {
    type?: AccountReasonTypeEnum;
}

export class ApiBaseReasonDetails extends ApiBaseReasonUpdate implements IApiBaseReasonDetails {
    id?: number;

    constructor(data?: IApiBaseReasonDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBaseReasonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiBaseReasonDetails extends IApiBaseReasonUpdate {
    id?: number;
}

export class ApiAccountReasonDetails extends ApiBaseReasonDetails implements IApiAccountReasonDetails {
    type?: AccountReasonTypeEnum;

    constructor(data?: IApiAccountReasonDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiAccountReasonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountReasonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountReasonDetails extends IApiBaseReasonDetails {
    type?: AccountReasonTypeEnum;
}

export class ApiPageResultOfApiMemberReasonUsageListItem implements IApiPageResultOfApiMemberReasonUsageListItem {
    items?: ApiMemberReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiMemberReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiMemberReasonUsageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiMemberReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiMemberReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiMemberReasonUsageListItem {
    items?: ApiMemberReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiMemberReasonUsageListItem implements IApiMemberReasonUsageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => String)
    performerFullName?: string | null;
    @columnMap(() => Date)
    performedDateTime?: Date;
    performerMemberId?: number;

    constructor(data?: IApiMemberReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.performerFullName = _data["performerFullName"] !== undefined ? _data["performerFullName"] : null as any;
            this.performedDateTime = _data["performedDateTime"] ? new Date(_data["performedDateTime"].toString()) : null as any;
            this.performerMemberId = _data["performerMemberId"] !== undefined ? _data["performerMemberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["performerFullName"] = this.performerFullName !== undefined ? this.performerFullName : null as any;
        data["performedDateTime"] = this.performedDateTime ? this.performedDateTime.toISOString() : null as any;
        data["performerMemberId"] = this.performerMemberId !== undefined ? this.performerMemberId : null as any;
        return data;
    }
}

export interface IApiMemberReasonUsageListItem {
    id?: number;
    memberDetails?: ApiMemberInfo | null;
    performerFullName?: string | null;
    performedDateTime?: Date;
    performerMemberId?: number;
}

export class ApiPageResultOfApiOrganizationReasonUsageListItem implements IApiPageResultOfApiOrganizationReasonUsageListItem {
    items?: ApiOrganizationReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiOrganizationReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiOrganizationReasonUsageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiOrganizationReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiOrganizationReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiOrganizationReasonUsageListItem {
    items?: ApiOrganizationReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiOrganizationReasonUsageListItem implements IApiOrganizationReasonUsageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiShortOrganizationInfo)
    shortOrganizationDetails?: ApiShortOrganizationInfo | null;
    @columnMap(() => String)
    performerFullName?: string | null;
    @columnMap(() => Date)
    performedDateTime?: Date;
    performerMemberId?: number;

    constructor(data?: IApiOrganizationReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortOrganizationDetails = _data["shortOrganizationDetails"] ? ApiShortOrganizationInfo.fromJS(_data["shortOrganizationDetails"]) : null as any;
            this.performerFullName = _data["performerFullName"] !== undefined ? _data["performerFullName"] : null as any;
            this.performedDateTime = _data["performedDateTime"] ? new Date(_data["performedDateTime"].toString()) : null as any;
            this.performerMemberId = _data["performerMemberId"] !== undefined ? _data["performerMemberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortOrganizationDetails"] = this.shortOrganizationDetails ? this.shortOrganizationDetails.toJSON() : null as any;
        data["performerFullName"] = this.performerFullName !== undefined ? this.performerFullName : null as any;
        data["performedDateTime"] = this.performedDateTime ? this.performedDateTime.toISOString() : null as any;
        data["performerMemberId"] = this.performerMemberId !== undefined ? this.performerMemberId : null as any;
        return data;
    }
}

export interface IApiOrganizationReasonUsageListItem {
    id?: number;
    shortOrganizationDetails?: ApiShortOrganizationInfo | null;
    performerFullName?: string | null;
    performedDateTime?: Date;
    performerMemberId?: number;
}

export class ApiShortOrganizationInfo implements IApiShortOrganizationInfo {
    id?: number;
    name?: string | null;
    email?: string | null;
    nameEmailAndId?: string | null;
    hasAvatar?: boolean;

    constructor(data?: IApiShortOrganizationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nameEmailAndId = _data["nameEmailAndId"] !== undefined ? _data["nameEmailAndId"] : null as any;
            this.hasAvatar = _data["hasAvatar"] !== undefined ? _data["hasAvatar"] : null as any;
        }
    }

    static fromJS(data: any): ApiShortOrganizationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiShortOrganizationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nameEmailAndId"] = this.nameEmailAndId !== undefined ? this.nameEmailAndId : null as any;
        data["hasAvatar"] = this.hasAvatar !== undefined ? this.hasAvatar : null as any;
        return data;
    }
}

export interface IApiShortOrganizationInfo {
    id?: number;
    name?: string | null;
    email?: string | null;
    nameEmailAndId?: string | null;
    hasAvatar?: boolean;
}

export class ApiPageResultOfApiGroupReasonUsageListItem implements IApiPageResultOfApiGroupReasonUsageListItem {
    items?: ApiGroupReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiGroupReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiGroupReasonUsageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiGroupReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiGroupReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiGroupReasonUsageListItem {
    items?: ApiGroupReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiGroupReasonUsageListItem implements IApiGroupReasonUsageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiGroupInfo)
    groupDetails?: ApiGroupInfo | null;
    @columnMap(() => String)
    performerFullName?: string | null;
    @columnMap(() => Date)
    performedDateTime?: Date;
    performerMemberId?: number;

    constructor(data?: IApiGroupReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.groupDetails = _data["groupDetails"] ? ApiGroupInfo.fromJS(_data["groupDetails"]) : null as any;
            this.performerFullName = _data["performerFullName"] !== undefined ? _data["performerFullName"] : null as any;
            this.performedDateTime = _data["performedDateTime"] ? new Date(_data["performedDateTime"].toString()) : null as any;
            this.performerMemberId = _data["performerMemberId"] !== undefined ? _data["performerMemberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["groupDetails"] = this.groupDetails ? this.groupDetails.toJSON() : null as any;
        data["performerFullName"] = this.performerFullName !== undefined ? this.performerFullName : null as any;
        data["performedDateTime"] = this.performedDateTime ? this.performedDateTime.toISOString() : null as any;
        data["performerMemberId"] = this.performerMemberId !== undefined ? this.performerMemberId : null as any;
        return data;
    }
}

export interface IApiGroupReasonUsageListItem {
    id?: number;
    groupDetails?: ApiGroupInfo | null;
    performerFullName?: string | null;
    performedDateTime?: Date;
    performerMemberId?: number;
}

export class ApiGroupInfo implements IApiGroupInfo {
    id?: number;
    name?: string | null;
    nameAndId?: string | null;

    constructor(data?: IApiGroupInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.nameAndId = _data["nameAndId"] !== undefined ? _data["nameAndId"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["nameAndId"] = this.nameAndId !== undefined ? this.nameAndId : null as any;
        return data;
    }
}

export interface IApiGroupInfo {
    id?: number;
    name?: string | null;
    nameAndId?: string | null;
}

export class ApiAccountReasonDropdownItem extends ApiIdNameItem implements IApiAccountReasonDropdownItem {

    constructor(data?: IApiAccountReasonDropdownItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiAccountReasonDropdownItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountReasonDropdownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountReasonDropdownItem extends IApiIdNameItem {
}

export abstract class ApiBaseReasonUsageDetails implements IApiBaseReasonUsageDetails {
    id?: number;
    value?: string | null;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    updaterFullName?: string | null;
    updaterId?: number;
    lastUpdated?: Date;

    constructor(data?: IApiBaseReasonUsageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : null as any;
            this.updaterFullName = _data["updaterFullName"] !== undefined ? _data["updaterFullName"] : null as any;
            this.updaterId = _data["updaterId"] !== undefined ? _data["updaterId"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonUsageDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReasonUsageDetails' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["updaterFullName"] = this.updaterFullName !== undefined ? this.updaterFullName : null as any;
        data["updaterId"] = this.updaterId !== undefined ? this.updaterId : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        return data;
    }
}

export interface IApiBaseReasonUsageDetails {
    id?: number;
    value?: string | null;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    updaterFullName?: string | null;
    updaterId?: number;
    lastUpdated?: Date;
}

export class ApiAccountReasonUsageDetails extends ApiBaseReasonUsageDetails implements IApiAccountReasonUsageDetails {
    type?: AccountReasonTypeEnum;

    constructor(data?: IApiAccountReasonUsageDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiAccountReasonUsageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountReasonUsageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountReasonUsageDetails extends IApiBaseReasonUsageDetails {
    type?: AccountReasonTypeEnum;
}

export class ApiPageResultOfApiRoleMemberListItem implements IApiPageResultOfApiRoleMemberListItem {
    items?: ApiRoleMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiRoleMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiRoleMemberListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiRoleMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiRoleMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiRoleMemberListItem {
    items?: ApiRoleMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiRoleMemberListItem implements IApiRoleMemberListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => Date)
    dateOfJoining?: Date;
    @columnMap(() => ApiMemberAccountStatusEnum)
    memberStatus?: ApiMemberAccountStatusEnum;

    constructor(data?: IApiRoleMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.dateOfJoining = _data["dateOfJoining"] ? new Date(_data["dateOfJoining"].toString()) : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApiRoleMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRoleMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        return data;
    }
}

export interface IApiRoleMemberListItem {
    memberId?: number;
    memberDetails?: ApiMemberInfo | null;
    dateOfJoining?: Date;
    memberStatus?: ApiMemberAccountStatusEnum;
}

export enum ApiMemberAccountStatusEnum {
    Active = 0,
    Deactivated = 1,
    Unverified = 3,
}

export class ApiServicePermissions implements IApiServicePermissions {
    service?: ServicesEnum;
    modules?: ApiModulePermissions[] | null;

    constructor(data?: IApiServicePermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] !== undefined ? _data["service"] : null as any;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ApiModulePermissions.fromJS(item));
            }
            else {
                this.modules = null as any;
            }
        }
    }

    static fromJS(data: any): ApiServicePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiServicePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service !== undefined ? this.service : null as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiServicePermissions {
    service?: ServicesEnum;
    modules?: ApiModulePermissions[] | null;
}

export class ApiModulePermissions implements IApiModulePermissions {
    module?: Module;
    active?: boolean;
    availablePermissions?: Permission[] | null;
    permissions?: Permission[] | null;

    constructor(data?: IApiModulePermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] !== undefined ? _data["module"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            if (Array.isArray(_data["availablePermissions"])) {
                this.availablePermissions = [] as any;
                for (let item of _data["availablePermissions"])
                    this.availablePermissions!.push(item);
            }
            else {
                this.availablePermissions = null as any;
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): ApiModulePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiModulePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module !== undefined ? this.module : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        if (Array.isArray(this.availablePermissions)) {
            data["availablePermissions"] = [];
            for (let item of this.availablePermissions)
                data["availablePermissions"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IApiModulePermissions {
    module?: Module;
    active?: boolean;
    availablePermissions?: Permission[] | null;
    permissions?: Permission[] | null;
}

export class ApiPageResultOfApiRoleListItem implements IApiPageResultOfApiRoleListItem {
    items?: ApiRoleListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiRoleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiRoleListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiRoleListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiRoleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiRoleListItem {
    items?: ApiRoleListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiRoleListItem implements IApiRoleListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => String)
    description?: string | null;
    @columnMap(() => Number)
    membersCount?: number;
    @columnMap(() => RoleTypeEnum)
    type?: RoleTypeEnum;
    editable?: boolean;

    constructor(data?: IApiRoleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.membersCount = _data["membersCount"] !== undefined ? _data["membersCount"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.editable = _data["editable"] !== undefined ? _data["editable"] : null as any;
        }
    }

    static fromJS(data: any): ApiRoleListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRoleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["membersCount"] = this.membersCount !== undefined ? this.membersCount : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["editable"] = this.editable !== undefined ? this.editable : null as any;
        return data;
    }
}

export interface IApiRoleListItem {
    id?: number;
    name?: string | null;
    description?: string | null;
    membersCount?: number;
    type?: RoleTypeEnum;
    editable?: boolean;
}

export enum RoleTypeEnum {
    Internal = 0,
    Public = 1,
}

export class ApiRoleName implements IApiRoleName {
    id?: number;
    name?: string | null;
    isInternal?: boolean;

    constructor(data?: IApiRoleName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isInternal = _data["isInternal"] !== undefined ? _data["isInternal"] : null as any;
        }
    }

    static fromJS(data: any): ApiRoleName {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRoleName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null as any;
        return data;
    }
}

export interface IApiRoleName {
    id?: number;
    name?: string | null;
    isInternal?: boolean;
}

export class ApiRole implements IApiRole {
    id?: number;
    name?: string | null;
    cloneFromRoleId?: number | null;
    description?: string | null;
    canManageMembers?: boolean;
    isPublic?: boolean;

    constructor(data?: IApiRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.cloneFromRoleId = _data["cloneFromRoleId"] !== undefined ? _data["cloneFromRoleId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.canManageMembers = _data["canManageMembers"] !== undefined ? _data["canManageMembers"] : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
        }
    }

    static fromJS(data: any): ApiRole {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["cloneFromRoleId"] = this.cloneFromRoleId !== undefined ? this.cloneFromRoleId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["canManageMembers"] = this.canManageMembers !== undefined ? this.canManageMembers : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        return data;
    }
}

export interface IApiRole {
    id?: number;
    name?: string | null;
    cloneFromRoleId?: number | null;
    description?: string | null;
    canManageMembers?: boolean;
    isPublic?: boolean;
}

export class ApiPageResultOfApiOrganizationGroupListItem implements IApiPageResultOfApiOrganizationGroupListItem {
    items?: ApiOrganizationGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiOrganizationGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiOrganizationGroupListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiOrganizationGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiOrganizationGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiOrganizationGroupListItem {
    items?: ApiOrganizationGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiOrganizationGroupListItem implements IApiOrganizationGroupListItem {
    @columnMap(() => Number)
    @keyMap()
    groupId?: number;
    @columnMap(() => String)
    groupName?: string | null;
    @columnMap(() => ApiGroupTypeEnum, true)
    groupType?: ApiGroupTypeEnum[] | null;
    @columnMap(() => GroupStatusEnum)
    groupStatus?: GroupStatusEnum;
    @columnMap(() => AccessTypeEnum, true)
    accessTo?: AccessTypeEnum[] | null;
    @columnMap(() => Date)
    dateAdded?: Date;

    constructor(data?: IApiOrganizationGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            if (Array.isArray(_data["groupType"])) {
                this.groupType = [] as any;
                for (let item of _data["groupType"])
                    this.groupType!.push(item);
            }
            else {
                this.groupType = null as any;
            }
            this.groupStatus = _data["groupStatus"] !== undefined ? _data["groupStatus"] : null as any;
            if (Array.isArray(_data["accessTo"])) {
                this.accessTo = [] as any;
                for (let item of _data["accessTo"])
                    this.accessTo!.push(item);
            }
            else {
                this.accessTo = null as any;
            }
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        if (Array.isArray(this.groupType)) {
            data["groupType"] = [];
            for (let item of this.groupType)
                data["groupType"].push(item);
        }
        data["groupStatus"] = this.groupStatus !== undefined ? this.groupStatus : null as any;
        if (Array.isArray(this.accessTo)) {
            data["accessTo"] = [];
            for (let item of this.accessTo)
                data["accessTo"].push(item);
        }
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        return data;
    }
}

export interface IApiOrganizationGroupListItem {
    groupId?: number;
    groupName?: string | null;
    groupType?: ApiGroupTypeEnum[] | null;
    groupStatus?: GroupStatusEnum;
    accessTo?: AccessTypeEnum[] | null;
    dateAdded?: Date;
}

export enum ApiGroupTypeEnum {
    Mailing = 0,
    Access = 1,
}

export enum GroupStatusEnum {
    Active = 0,
    Deactivated = 1,
}

export enum AccessTypeEnum {
    PWPapers = 0,
    PWeBooks = 1,
    IPPapers = 2,
    IPeBooks = 3,
}

export class ApiOrganization implements IApiOrganization {
    id?: number;
    isInternal?: boolean;
    hasPrimaryContact?: boolean;
    details?: ApiOrganizationDetails | null;
    activity?: ApiOrganizationActivity | null;
    head?: ApiOrganizationHead | null;
    info?: ApiOrganizationInfo | null;

    constructor(data?: IApiOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isInternal = _data["isInternal"] !== undefined ? _data["isInternal"] : null as any;
            this.hasPrimaryContact = _data["hasPrimaryContact"] !== undefined ? _data["hasPrimaryContact"] : null as any;
            this.details = _data["details"] ? ApiOrganizationDetails.fromJS(_data["details"]) : null as any;
            this.activity = _data["activity"] ? ApiOrganizationActivity.fromJS(_data["activity"]) : null as any;
            this.head = _data["head"] ? ApiOrganizationHead.fromJS(_data["head"]) : null as any;
            this.info = _data["info"] ? ApiOrganizationInfo.fromJS(_data["info"]) : null as any;
        }
    }

    static fromJS(data: any): ApiOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null as any;
        data["hasPrimaryContact"] = this.hasPrimaryContact !== undefined ? this.hasPrimaryContact : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        data["head"] = this.head ? this.head.toJSON() : null as any;
        data["info"] = this.info ? this.info.toJSON() : null as any;
        return data;
    }
}

export interface IApiOrganization {
    id?: number;
    isInternal?: boolean;
    hasPrimaryContact?: boolean;
    details?: ApiOrganizationDetails | null;
    activity?: ApiOrganizationActivity | null;
    head?: ApiOrganizationHead | null;
    info?: ApiOrganizationInfo | null;
}

export class ApiOrganizationDetails implements IApiOrganizationDetails {
    id?: number;
    gridId?: string | null;
    type?: OrganizationTypeEnum;
    name?: string | null;
    department?: string | null;
    email?: string | null;
    phone?: string | null;
    vat?: string | null;
    websites?: string[] | null;

    constructor(data?: IApiOrganizationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiOrganizationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiOrganizationDetails {
    id?: number;
    gridId?: string | null;
    type?: OrganizationTypeEnum;
    name?: string | null;
    department?: string | null;
    email?: string | null;
    phone?: string | null;
    vat?: string | null;
    websites?: string[] | null;
}

export enum OrganizationTypeEnum {
    Library = 0,
    Institution = 1,
    Corporation = 2,
}

export class ApiAccountActivity implements IApiAccountActivity {
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;
    dateOfJoining?: Date;

    constructor(data?: IApiAccountActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifierId = _data["modifierId"] !== undefined ? _data["modifierId"] : null as any;
            this.modifierFullName = _data["modifierFullName"] !== undefined ? _data["modifierFullName"] : null as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : null as any;
            this.dateOfJoining = _data["dateOfJoining"] ? new Date(_data["dateOfJoining"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiAccountActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifierId"] = this.modifierId !== undefined ? this.modifierId : null as any;
        data["modifierFullName"] = this.modifierFullName !== undefined ? this.modifierFullName : null as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null as any;
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : null as any;
        return data;
    }
}

export interface IApiAccountActivity {
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;
    dateOfJoining?: Date;
}

export class ApiOrganizationActivity extends ApiAccountActivity implements IApiOrganizationActivity {
    creatorId?: number;
    creatorFullName?: string | null;

    constructor(data?: IApiOrganizationActivity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiOrganizationActivity extends IApiAccountActivity {
    creatorId?: number;
    creatorFullName?: string | null;
}

export class ApiOrganizationHead implements IApiOrganizationHead {
    firstName?: string | null;
    lastName?: string | null;
    position?: string | null;
    email?: string | null;

    constructor(data?: IApiOrganizationHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationHead {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiOrganizationHead {
    firstName?: string | null;
    lastName?: string | null;
    position?: string | null;
    email?: string | null;
}

export class ApiOrganizationInfo implements IApiOrganizationInfo {
    status?: ApiOrganizationAccountStatusEnum;
    showReasons?: boolean;
    accessTypes?: AccessTypeEnum[] | null;

    constructor(data?: IApiOrganizationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.showReasons = _data["showReasons"] !== undefined ? _data["showReasons"] : null as any;
            if (Array.isArray(_data["accessTypes"])) {
                this.accessTypes = [] as any;
                for (let item of _data["accessTypes"])
                    this.accessTypes!.push(item);
            }
            else {
                this.accessTypes = null as any;
            }
        }
    }

    static fromJS(data: any): ApiOrganizationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["showReasons"] = this.showReasons !== undefined ? this.showReasons : null as any;
        if (Array.isArray(this.accessTypes)) {
            data["accessTypes"] = [];
            for (let item of this.accessTypes)
                data["accessTypes"].push(item);
        }
        return data;
    }
}

export interface IApiOrganizationInfo {
    status?: ApiOrganizationAccountStatusEnum;
    showReasons?: boolean;
    accessTypes?: AccessTypeEnum[] | null;
}

export enum ApiOrganizationAccountStatusEnum {
    Active = 0,
    Deactivated = 1,
    Pending = 2,
}

export class ApiPageResultOfApiOrganizationListItem implements IApiPageResultOfApiOrganizationListItem {
    items?: ApiOrganizationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiOrganizationListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiOrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiOrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiOrganizationListItem {
    items?: ApiOrganizationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiOrganizationListItem implements IApiOrganizationListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => OrganizationTypeEnum)
    type?: OrganizationTypeEnum;
    @columnMap(() => ApiOrganizationAccountStatusEnum)
    status?: ApiOrganizationAccountStatusEnum;
    @columnMap(() => String, true)
    emails?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => ApiNamedListItem)
    primaryContact?: ApiNamedListItem | null;
    @columnMap(() => ApiOrganizationTagEnum)
    tag?: ApiOrganizationTagEnum | null;
    @columnMap(() => String)
    department?: string | null;
    @columnMap(() => String)
    city?: string | null;
    @columnMap(() => String)
    state?: string | null;
    @columnMap(() => String, true)
    websites?: string[] | null;
    @columnMap(() => Boolean)
    groupsMembership?: boolean;
    @columnMap(() => ApiNamedListItem, true)
    groups?: ApiNamedListItem[] | null;
    @columnMap(() => Boolean)
    ipAccess?: boolean;
    @columnMap(() => String)
    ipAddress?: string | null;
    @columnMap(() => Boolean)
    ipBlacklist?: boolean;
    @columnMap(() => Date)
    createdDateTime?: Date;

    constructor(data?: IApiOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = null as any;
            }
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.primaryContact = _data["primaryContact"] ? ApiNamedListItem.fromJS(_data["primaryContact"]) : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
            this.groupsMembership = _data["groupsMembership"] !== undefined ? _data["groupsMembership"] : null as any;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.groups = null as any;
            }
            this.ipAccess = _data["ipAccess"] !== undefined ? _data["ipAccess"] : null as any;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : null as any;
            this.ipBlacklist = _data["ipBlacklist"] !== undefined ? _data["ipBlacklist"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["primaryContact"] = this.primaryContact ? this.primaryContact.toJSON() : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        data["groupsMembership"] = this.groupsMembership !== undefined ? this.groupsMembership : null as any;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : null as any);
        }
        data["ipAccess"] = this.ipAccess !== undefined ? this.ipAccess : null as any;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null as any;
        data["ipBlacklist"] = this.ipBlacklist !== undefined ? this.ipBlacklist : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiOrganizationListItem {
    id?: number;
    name?: string | null;
    type?: OrganizationTypeEnum;
    status?: ApiOrganizationAccountStatusEnum;
    emails?: string[] | null;
    country?: ApiNamedListItem | null;
    primaryContact?: ApiNamedListItem | null;
    tag?: ApiOrganizationTagEnum | null;
    department?: string | null;
    city?: string | null;
    state?: string | null;
    websites?: string[] | null;
    groupsMembership?: boolean;
    groups?: ApiNamedListItem[] | null;
    ipAccess?: boolean;
    ipAddress?: string | null;
    ipBlacklist?: boolean;
    createdDateTime?: Date;
}

export enum ApiOrganizationTagEnum {
    Internal = 0,
}

export class ExportDefinition implements IExportDefinition {
    fileName?: string | null;
    columns?: { [key: string]: string; } | null;

    constructor(data?: IExportDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            if (_data["columns"]) {
                this.columns = {} as any;
                for (let key in _data["columns"]) {
                    if (_data["columns"].hasOwnProperty(key))
                        (this.columns as any)![key] = _data["columns"][key] !== undefined ? _data["columns"][key] : null as any;
                }
            }
            else {
                this.columns = null as any;
            }
        }
    }

    static fromJS(data: any): ExportDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        if (this.columns) {
            data["columns"] = {};
            for (let key in this.columns) {
                if (this.columns.hasOwnProperty(key))
                    (data["columns"] as any)[key] = this.columns[key] !== undefined ? this.columns[key] : null as any;
            }
        }
        return data;
    }
}

export interface IExportDefinition {
    fileName?: string | null;
    columns?: { [key: string]: string; } | null;
}

export class ApiOrganizationCreateRequest implements IApiOrganizationCreateRequest {
    internal?: boolean;
    type?: OrganizationTypeEnum;
    name?: string | null;
    department?: string | null;
    email?: string | null;
    primaryContactMemberId?: number | null;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;
    gridId?: string | null;

    constructor(data?: IApiOrganizationCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internal = _data["internal"] !== undefined ? _data["internal"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.primaryContactMemberId = _data["primaryContactMemberId"] !== undefined ? _data["primaryContactMemberId"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internal"] = this.internal !== undefined ? this.internal : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["primaryContactMemberId"] = this.primaryContactMemberId !== undefined ? this.primaryContactMemberId : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        return data;
    }
}

export interface IApiOrganizationCreateRequest {
    internal?: boolean;
    type?: OrganizationTypeEnum;
    name?: string | null;
    department?: string | null;
    email?: string | null;
    primaryContactMemberId?: number | null;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;
    gridId?: string | null;
}

export enum MakePublicErrorsEnum {
    MembersMissing = 0,
    AlreadyPublic = 1,
}

export class ApiActivateDeactivate implements IApiActivateDeactivate {
    reasonId: number;
    note?: string | null;

    constructor(data?: IApiActivateDeactivate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"] !== undefined ? _data["reasonId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ApiActivateDeactivate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiActivateDeactivate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId !== undefined ? this.reasonId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IApiActivateDeactivate {
    reasonId: number;
    note?: string | null;
}

export class ApiAccountAddress implements IApiAccountAddress {
    addressType?: AccountAddressTypeEnum;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    vat?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    websites?: string[] | null;

    constructor(data?: IApiAccountAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiAccountAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType !== undefined ? this.addressType : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiAccountAddress {
    addressType?: AccountAddressTypeEnum;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    vat?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    websites?: string[] | null;
}

export abstract class ApiAccountAddressDetails extends ApiAccountAddress implements IApiAccountAddressDetails {
    id?: number;
    accountId?: number;
    countryName?: string | null;
    registeredTime?: Date | null;
    lastUpdated?: Date | null;

    constructor(data?: IApiAccountAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.registeredTime = _data["registeredTime"] ? new Date(_data["registeredTime"].toString()) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiAccountAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiAccountAddressDetails' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["registeredTime"] = this.registeredTime ? this.registeredTime.toISOString() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountAddressDetails extends IApiAccountAddress {
    id?: number;
    accountId?: number;
    countryName?: string | null;
    registeredTime?: Date | null;
    lastUpdated?: Date | null;
}

export class ApiOrganizationAddressDetails extends ApiAccountAddressDetails implements IApiOrganizationAddressDetails {

    constructor(data?: IApiOrganizationAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiOrganizationAddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationAddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiOrganizationAddressDetails extends IApiAccountAddressDetails {
}

export enum AccountAddressTypeEnum {
    Main = 0,
    Delivery = 1,
    Billing = 2,
    Shipping = 3,
}

export class ApiPageResultOfApiAttachmentListItem implements IApiPageResultOfApiAttachmentListItem {
    items?: ApiAttachmentListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiAttachmentListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiAttachmentListItem {
    items?: ApiAttachmentListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiAttachmentListItem implements IApiAttachmentListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;
    @columnMap(() => ApiMemberInfo)
    createdBy?: ApiMemberInfo | null;
    @columnMap(() => Date)
    added?: Date;
    noteCount?: number;

    constructor(data?: IApiAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.createdBy = _data["createdBy"] ? ApiMemberInfo.fromJS(_data["createdBy"]) : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
            this.noteCount = _data["noteCount"] !== undefined ? _data["noteCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        data["noteCount"] = this.noteCount !== undefined ? this.noteCount : null as any;
        return data;
    }
}

export interface IApiAttachmentListItem {
    id?: number;
    file?: ApiFileInfo | null;
    createdBy?: ApiMemberInfo | null;
    added?: Date;
    noteCount?: number;
}

export class ApiOrganizationHeader implements IApiOrganizationHeader {
    id?: number;
    internal?: boolean;
    hasAvatar?: boolean;
    status?: ApiOrganizationAccountStatusEnum;
    name?: string | null;
    hasPrimaryContact?: boolean;
    primaryContact?: ApiOrganizationRelatedMember | null;
    showReasons?: boolean;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IApiOrganizationHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.internal = _data["internal"] !== undefined ? _data["internal"] : null as any;
            this.hasAvatar = _data["hasAvatar"] !== undefined ? _data["hasAvatar"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.hasPrimaryContact = _data["hasPrimaryContact"] !== undefined ? _data["hasPrimaryContact"] : null as any;
            this.primaryContact = _data["primaryContact"] ? ApiOrganizationRelatedMember.fromJS(_data["primaryContact"]) : null as any;
            this.showReasons = _data["showReasons"] !== undefined ? _data["showReasons"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["internal"] = this.internal !== undefined ? this.internal : null as any;
        data["hasAvatar"] = this.hasAvatar !== undefined ? this.hasAvatar : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["hasPrimaryContact"] = this.hasPrimaryContact !== undefined ? this.hasPrimaryContact : null as any;
        data["primaryContact"] = this.primaryContact ? this.primaryContact.toJSON() : null as any;
        data["showReasons"] = this.showReasons !== undefined ? this.showReasons : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        return data;
    }
}

export interface IApiOrganizationHeader {
    id?: number;
    internal?: boolean;
    hasAvatar?: boolean;
    status?: ApiOrganizationAccountStatusEnum;
    name?: string | null;
    hasPrimaryContact?: boolean;
    primaryContact?: ApiOrganizationRelatedMember | null;
    showReasons?: boolean;
    email?: string | null;
    phone?: string | null;
}

export class ApiOrganizationRelatedMember implements IApiOrganizationRelatedMember {
    memberId?: number;
    organizationId?: number;
    contactType?: OrganizationRelatedMemberTypeEnum;
    fullName?: string | null;
    accountStatus?: ApiMemberAccountStatusEnum;

    constructor(data?: IApiOrganizationRelatedMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : null as any;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationRelatedMember {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationRelatedMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : null as any;
        data["contactType"] = this.contactType !== undefined ? this.contactType : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null as any;
        return data;
    }
}

export interface IApiOrganizationRelatedMember {
    memberId?: number;
    organizationId?: number;
    contactType?: OrganizationRelatedMemberTypeEnum;
    fullName?: string | null;
    accountStatus?: ApiMemberAccountStatusEnum;
}

export enum OrganizationRelatedMemberTypeEnum {
    Primary = 0,
    InvoiceMember = 1,
    DeliveryMember = 2,
    Other = 3,
}

export class ApiPageResultOfApiNoteListItem implements IApiPageResultOfApiNoteListItem {
    items?: ApiNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiNoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiNoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiNoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiNoteListItem {
    items?: ApiNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPageResultOfApiReasonListItem implements IApiPageResultOfApiReasonListItem {
    items?: ApiReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiReasonListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiReasonListItem {
    items?: ApiReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiReasonListItem implements IApiReasonListItem {
    @keyMap()
    id?: number;
    @columnMap(() => AccountReasonTypeEnum)
    eventType?: AccountReasonTypeEnum;
    @columnMap(() => String)
    reasonText?: string | null;
    @columnMap(() => String)
    performer?: string | null;
    performerId?: number;
    @columnMap(() => Date)
    lastUpdated?: Date;
    @columnMap(() => Number)
    countOfNotes?: number;

    constructor(data?: IApiReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.reasonText = _data["reasonText"] !== undefined ? _data["reasonText"] : null as any;
            this.performer = _data["performer"] !== undefined ? _data["performer"] : null as any;
            this.performerId = _data["performerId"] !== undefined ? _data["performerId"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.countOfNotes = _data["countOfNotes"] !== undefined ? _data["countOfNotes"] : null as any;
        }
    }

    static fromJS(data: any): ApiReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["reasonText"] = this.reasonText !== undefined ? this.reasonText : null as any;
        data["performer"] = this.performer !== undefined ? this.performer : null as any;
        data["performerId"] = this.performerId !== undefined ? this.performerId : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["countOfNotes"] = this.countOfNotes !== undefined ? this.countOfNotes : null as any;
        return data;
    }
}

export interface IApiReasonListItem {
    id?: number;
    eventType?: AccountReasonTypeEnum;
    reasonText?: string | null;
    performer?: string | null;
    performerId?: number;
    lastUpdated?: Date;
    countOfNotes?: number;
}

export class ApiPageResultOfApiOrganizationRelatedMemberListItem implements IApiPageResultOfApiOrganizationRelatedMemberListItem {
    items?: ApiOrganizationRelatedMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiOrganizationRelatedMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiOrganizationRelatedMemberListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiOrganizationRelatedMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiOrganizationRelatedMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiOrganizationRelatedMemberListItem {
    items?: ApiOrganizationRelatedMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiOrganizationRelatedMemberListItem implements IApiOrganizationRelatedMemberListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => OrganizationRelatedMemberTypeEnum)
    contactType?: OrganizationRelatedMemberTypeEnum;
    @columnMap(() => ApiMemberAccountStatusEnum)
    memberStatus?: ApiMemberAccountStatusEnum;
    @columnMap(() => OrganizationRelatedMemberStatusEnum)
    connectionStatus?: OrganizationRelatedMemberStatusEnum;
    @columnMap(() => Date)
    added?: Date;

    constructor(data?: IApiOrganizationRelatedMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            this.connectionStatus = _data["connectionStatus"] !== undefined ? _data["connectionStatus"] : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationRelatedMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationRelatedMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["contactType"] = this.contactType !== undefined ? this.contactType : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        data["connectionStatus"] = this.connectionStatus !== undefined ? this.connectionStatus : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        return data;
    }
}

export interface IApiOrganizationRelatedMemberListItem {
    memberId?: number;
    memberDetails?: ApiMemberInfo | null;
    contactType?: OrganizationRelatedMemberTypeEnum;
    memberStatus?: ApiMemberAccountStatusEnum;
    connectionStatus?: OrganizationRelatedMemberStatusEnum;
    added?: Date;
}

export enum OrganizationRelatedMemberStatusEnum {
    Unsettled = 0,
    Pending = 1,
    Approved = 2,
}

export class ApiOrganizationRelatedMemberCreateRequest implements IApiOrganizationRelatedMemberCreateRequest {
    memberIds?: number[] | null;
    contactType?: OrganizationRelatedMemberTypeEnum;
    notifyMembers?: boolean;

    constructor(data?: IApiOrganizationRelatedMemberCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberIds"])) {
                this.memberIds = [] as any;
                for (let item of _data["memberIds"])
                    this.memberIds!.push(item);
            }
            else {
                this.memberIds = null as any;
            }
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : null as any;
            this.notifyMembers = _data["notifyMembers"] !== undefined ? _data["notifyMembers"] : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationRelatedMemberCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationRelatedMemberCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberIds)) {
            data["memberIds"] = [];
            for (let item of this.memberIds)
                data["memberIds"].push(item);
        }
        data["contactType"] = this.contactType !== undefined ? this.contactType : null as any;
        data["notifyMembers"] = this.notifyMembers !== undefined ? this.notifyMembers : null as any;
        return data;
    }
}

export interface IApiOrganizationRelatedMemberCreateRequest {
    memberIds?: number[] | null;
    contactType?: OrganizationRelatedMemberTypeEnum;
    notifyMembers?: boolean;
}

export class ApiPageResultOfApiEmailSettingsListItem implements IApiPageResultOfApiEmailSettingsListItem {
    items?: ApiEmailSettingsListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEmailSettingsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEmailSettingsListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEmailSettingsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEmailSettingsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEmailSettingsListItem {
    items?: ApiEmailSettingsListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEmailSettingsListItem implements IApiEmailSettingsListItem {
    @columnMap(() => String)
    @keyMap()
    email?: string | null;
    @columnMap(() => EmailTypeEnum)
    emailType?: EmailTypeEnum;
    @columnMap(() => EmailStatusEnum)
    emailStatus?: EmailStatusEnum;
    @columnMap(() => Date)
    lastUpdated?: Date;
    @columnMap(() => String)
    informationType?: string | null;
    isEditable?: boolean;
    canMoveToUsed?: boolean;
    canSendVerificationLink?: boolean;
    sentVerificationLink?: boolean;
    id?: number;

    constructor(data?: IApiEmailSettingsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.emailType = _data["emailType"] !== undefined ? _data["emailType"] : null as any;
            this.emailStatus = _data["emailStatus"] !== undefined ? _data["emailStatus"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.informationType = _data["informationType"] !== undefined ? _data["informationType"] : null as any;
            this.isEditable = _data["isEditable"] !== undefined ? _data["isEditable"] : null as any;
            this.canMoveToUsed = _data["canMoveToUsed"] !== undefined ? _data["canMoveToUsed"] : null as any;
            this.canSendVerificationLink = _data["canSendVerificationLink"] !== undefined ? _data["canSendVerificationLink"] : null as any;
            this.sentVerificationLink = _data["sentVerificationLink"] !== undefined ? _data["sentVerificationLink"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ApiEmailSettingsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEmailSettingsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["emailType"] = this.emailType !== undefined ? this.emailType : null as any;
        data["emailStatus"] = this.emailStatus !== undefined ? this.emailStatus : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["informationType"] = this.informationType !== undefined ? this.informationType : null as any;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : null as any;
        data["canMoveToUsed"] = this.canMoveToUsed !== undefined ? this.canMoveToUsed : null as any;
        data["canSendVerificationLink"] = this.canSendVerificationLink !== undefined ? this.canSendVerificationLink : null as any;
        data["sentVerificationLink"] = this.sentVerificationLink !== undefined ? this.sentVerificationLink : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IApiEmailSettingsListItem {
    email?: string | null;
    emailType?: EmailTypeEnum;
    emailStatus?: EmailStatusEnum;
    lastUpdated?: Date;
    informationType?: string | null;
    isEditable?: boolean;
    canMoveToUsed?: boolean;
    canSendVerificationLink?: boolean;
    sentVerificationLink?: boolean;
    id?: number;
}

export enum EmailTypeEnum {
    Primary = 0,
    Secondary = 1,
    Invoice = 2,
    Newsletter = 3,
    Pending = 4,
}

export enum EmailStatusEnum {
    Unverified = 0,
    Verified = 1,
    Used = 2,
}

export class ApiAddEmail implements IApiAddEmail {
    email: string;
    emailType?: EmailTypeEnum | null;
    sendVerificationLink?: boolean;

    constructor(data?: IApiAddEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.emailType = _data["emailType"] !== undefined ? _data["emailType"] : null as any;
            this.sendVerificationLink = _data["sendVerificationLink"] !== undefined ? _data["sendVerificationLink"] : null as any;
        }
    }

    static fromJS(data: any): ApiAddEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAddEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["emailType"] = this.emailType !== undefined ? this.emailType : null as any;
        data["sendVerificationLink"] = this.sendVerificationLink !== undefined ? this.sendVerificationLink : null as any;
        return data;
    }
}

export interface IApiAddEmail {
    email: string;
    emailType?: EmailTypeEnum | null;
    sendVerificationLink?: boolean;
}

export class ApiMemberAddressDetails extends ApiAccountAddressDetails implements IApiMemberAddressDetails {

    constructor(data?: IApiMemberAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiMemberAddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberAddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiMemberAddressDetails extends IApiAccountAddressDetails {
}

export class ApiMemberRegistrationResult implements IApiMemberRegistrationResult {
    success?: boolean;
    memberId?: number;

    constructor(data?: IApiMemberRegistrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberRegistrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberRegistrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        return data;
    }
}

export interface IApiMemberRegistrationResult {
    success?: boolean;
    memberId?: number;
}

export class ApiRegisterUserModel implements IApiRegisterUserModel {
    email: string;
    firstName: string;
    lastName: string;
    gender: Gender;
    countryId?: string | null;
    title?: string | null;
    roleIdList?: number[] | null;
    sendVerificationLink?: boolean;
    password?: string | null;
    orcidId?: string | null;
    researchGate?: string | null;

    constructor(data?: IApiRegisterUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["roleIdList"])) {
                this.roleIdList = [] as any;
                for (let item of _data["roleIdList"])
                    this.roleIdList!.push(item);
            }
            else {
                this.roleIdList = null as any;
            }
            this.sendVerificationLink = _data["sendVerificationLink"] !== undefined ? _data["sendVerificationLink"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            this.researchGate = _data["researchGate"] !== undefined ? _data["researchGate"] : null as any;
        }
    }

    static fromJS(data: any): ApiRegisterUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRegisterUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.roleIdList)) {
            data["roleIdList"] = [];
            for (let item of this.roleIdList)
                data["roleIdList"].push(item);
        }
        data["sendVerificationLink"] = this.sendVerificationLink !== undefined ? this.sendVerificationLink : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        data["researchGate"] = this.researchGate !== undefined ? this.researchGate : null as any;
        return data;
    }
}

export interface IApiRegisterUserModel {
    email: string;
    firstName: string;
    lastName: string;
    gender: Gender;
    countryId?: string | null;
    title?: string | null;
    roleIdList?: number[] | null;
    sendVerificationLink?: boolean;
    password?: string | null;
    orcidId?: string | null;
    researchGate?: string | null;
}

export class ApiForgotPasswordResponse implements IApiForgotPasswordResponse {
    successful?: boolean;
    active?: boolean;
    verified?: boolean;
    notFound?: boolean;
    notApplicableEmail?: boolean;
    memberId?: number | null;
    emailId?: number | null;

    constructor(data?: IApiForgotPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successful = _data["successful"] !== undefined ? _data["successful"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.verified = _data["verified"] !== undefined ? _data["verified"] : null as any;
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : null as any;
            this.notApplicableEmail = _data["notApplicableEmail"] !== undefined ? _data["notApplicableEmail"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.emailId = _data["emailId"] !== undefined ? _data["emailId"] : null as any;
        }
    }

    static fromJS(data: any): ApiForgotPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiForgotPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successful"] = this.successful !== undefined ? this.successful : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["verified"] = this.verified !== undefined ? this.verified : null as any;
        data["notFound"] = this.notFound !== undefined ? this.notFound : null as any;
        data["notApplicableEmail"] = this.notApplicableEmail !== undefined ? this.notApplicableEmail : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["emailId"] = this.emailId !== undefined ? this.emailId : null as any;
        return data;
    }
}

export interface IApiForgotPasswordResponse {
    successful?: boolean;
    active?: boolean;
    verified?: boolean;
    notFound?: boolean;
    notApplicableEmail?: boolean;
    memberId?: number | null;
    emailId?: number | null;
}

export class ApiEmailModel implements IApiEmailModel {
    email: string;

    constructor(data?: IApiEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiEmailModel {
    email: string;
}

export class ApiPasswordChangeDate implements IApiPasswordChangeDate {
    changeDate?: Date | null;

    constructor(data?: IApiPasswordChangeDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPasswordChangeDate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPasswordChangeDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : null as any;
        return data;
    }
}

export interface IApiPasswordChangeDate {
    changeDate?: Date | null;
}

export class ApiMemberRole implements IApiMemberRole {
    id?: number;
    roleName?: string | null;
    isInRole?: boolean;

    constructor(data?: IApiMemberRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.isInRole = _data["isInRole"] !== undefined ? _data["isInRole"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberRole {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["isInRole"] = this.isInRole !== undefined ? this.isInRole : null as any;
        return data;
    }
}

export interface IApiMemberRole {
    id?: number;
    roleName?: string | null;
    isInRole?: boolean;
}

export class ApiPageResultOfApiMemberListItem implements IApiPageResultOfApiMemberListItem {
    items?: ApiMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiMemberListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiMemberListItem {
    items?: ApiMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiMemberListItem implements IApiMemberListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String, true)
    emails?: string[] | null;
    @columnMap(() => String, true)
    authorEmails?: string[] | null;
    @columnMap(() => ApiMemberAccountStatusEnum)
    status?: ApiMemberAccountStatusEnum;
    @columnMap(() => String)
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;
    @columnMap(() => String, true)
    roles?: string[] | null;
    @columnMap(() => String)
    tag?: string | null;
    @columnMap(() => String)
    department?: string | null;
    @columnMap(() => String)
    city?: string | null;
    @columnMap(() => String)
    state?: string | null;
    @columnMap(() => String)
    orcidId?: string | null;
    @columnMap(() => String, true)
    socialNetworks?: string[] | null;
    @columnMap(() => Boolean)
    pwAccess?: boolean;
    @columnMap(() => Boolean)
    orgMembership?: boolean;
    @columnMap(() => ApiNamedListItem, true)
    relatedOrganizations?: ApiNamedListItem[] | null;
    @columnMap(() => Boolean)
    groupsMembership?: boolean;
    @columnMap(() => ApiNamedListItem, true)
    groups?: ApiNamedListItem[] | null;
    @columnMap(() => Boolean)
    journalResponsibilities?: boolean;
    @columnMap(() => String)
    phone?: string | null;
    @columnMap(() => Date)
    dateOfBirth?: Date | null;
    @columnMap(() => Gender)
    gender?: Gender | null;
    @columnMap(() => String, true)
    websites?: string[] | null;
    @columnMap(() => Date)
    dateOfJoining?: Date;
    @columnMap(() => Date)
    lastLoginDate?: Date | null;
    @columnMap(() => Number)
    loginCount?: number;
    @columnMap(() => Boolean)
    isContributor?: boolean;

    constructor(data?: IApiMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = null as any;
            }
            if (Array.isArray(_data["authorEmails"])) {
                this.authorEmails = [] as any;
                for (let item of _data["authorEmails"])
                    this.authorEmails!.push(item);
            }
            else {
                this.authorEmails = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            if (Array.isArray(_data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of _data["socialNetworks"])
                    this.socialNetworks!.push(item);
            }
            else {
                this.socialNetworks = null as any;
            }
            this.pwAccess = _data["pwAccess"] !== undefined ? _data["pwAccess"] : null as any;
            this.orgMembership = _data["orgMembership"] !== undefined ? _data["orgMembership"] : null as any;
            if (Array.isArray(_data["relatedOrganizations"])) {
                this.relatedOrganizations = [] as any;
                for (let item of _data["relatedOrganizations"])
                    this.relatedOrganizations!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.relatedOrganizations = null as any;
            }
            this.groupsMembership = _data["groupsMembership"] !== undefined ? _data["groupsMembership"] : null as any;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.groups = null as any;
            }
            this.journalResponsibilities = _data["journalResponsibilities"] !== undefined ? _data["journalResponsibilities"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
            this.dateOfJoining = _data["dateOfJoining"] ? new Date(_data["dateOfJoining"].toString()) : null as any;
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : null as any;
            this.loginCount = _data["loginCount"] !== undefined ? _data["loginCount"] : null as any;
            this.isContributor = _data["isContributor"] !== undefined ? _data["isContributor"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.authorEmails)) {
            data["authorEmails"] = [];
            for (let item of this.authorEmails)
                data["authorEmails"].push(item);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item);
        }
        data["pwAccess"] = this.pwAccess !== undefined ? this.pwAccess : null as any;
        data["orgMembership"] = this.orgMembership !== undefined ? this.orgMembership : null as any;
        if (Array.isArray(this.relatedOrganizations)) {
            data["relatedOrganizations"] = [];
            for (let item of this.relatedOrganizations)
                data["relatedOrganizations"].push(item ? item.toJSON() : null as any);
        }
        data["groupsMembership"] = this.groupsMembership !== undefined ? this.groupsMembership : null as any;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : null as any);
        }
        data["journalResponsibilities"] = this.journalResponsibilities !== undefined ? this.journalResponsibilities : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : null as any;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : null as any;
        data["loginCount"] = this.loginCount !== undefined ? this.loginCount : null as any;
        data["isContributor"] = this.isContributor !== undefined ? this.isContributor : null as any;
        return data;
    }
}

export interface IApiMemberListItem {
    id?: number;
    emails?: string[] | null;
    authorEmails?: string[] | null;
    status?: ApiMemberAccountStatusEnum;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    country?: ApiNamedListItem | null;
    universityOrOrganization?: string | null;
    roles?: string[] | null;
    tag?: string | null;
    department?: string | null;
    city?: string | null;
    state?: string | null;
    orcidId?: string | null;
    socialNetworks?: string[] | null;
    pwAccess?: boolean;
    orgMembership?: boolean;
    relatedOrganizations?: ApiNamedListItem[] | null;
    groupsMembership?: boolean;
    groups?: ApiNamedListItem[] | null;
    journalResponsibilities?: boolean;
    phone?: string | null;
    dateOfBirth?: Date | null;
    gender?: Gender | null;
    websites?: string[] | null;
    dateOfJoining?: Date;
    lastLoginDate?: Date | null;
    loginCount?: number;
    isContributor?: boolean;
}

export class ApiMember implements IApiMember {
    id?: number;
    fullName?: string | null;
    organizations?: string[] | null;
    email?: string | null;
    phone?: string | null;
    isCustomer?: boolean;
    isNew?: boolean;
    countryId?: string | null;
    affiliation?: ApiMemberAddressDetails | null;
    hasAvatar?: boolean;
    createdDateTime?: Date;
    isSuperAdmin?: boolean;
    title?: string | null;
    status?: ApiMemberAccountStatusEnum;
    roles?: string[] | null;
    showReasons?: boolean;
    accessTypes?: AccessTypeEnum[] | null;
    activity?: ApiMemberActivity | null;
    socialNetworks?: SocialNetworkEnum[] | null;
    socialProfiles?: ApiMemberSocialProfiles | null;

    constructor(data?: IApiMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(item);
            }
            else {
                this.organizations = null as any;
            }
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.isCustomer = _data["isCustomer"] !== undefined ? _data["isCustomer"] : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.affiliation = _data["affiliation"] ? ApiMemberAddressDetails.fromJS(_data["affiliation"]) : null as any;
            this.hasAvatar = _data["hasAvatar"] !== undefined ? _data["hasAvatar"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
            this.isSuperAdmin = _data["isSuperAdmin"] !== undefined ? _data["isSuperAdmin"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.showReasons = _data["showReasons"] !== undefined ? _data["showReasons"] : null as any;
            if (Array.isArray(_data["accessTypes"])) {
                this.accessTypes = [] as any;
                for (let item of _data["accessTypes"])
                    this.accessTypes!.push(item);
            }
            else {
                this.accessTypes = null as any;
            }
            this.activity = _data["activity"] ? ApiMemberActivity.fromJS(_data["activity"]) : null as any;
            if (Array.isArray(_data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of _data["socialNetworks"])
                    this.socialNetworks!.push(item);
            }
            else {
                this.socialNetworks = null as any;
            }
            this.socialProfiles = _data["socialProfiles"] ? ApiMemberSocialProfiles.fromJS(_data["socialProfiles"]) : null as any;
        }
    }

    static fromJS(data: any): ApiMember {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item);
        }
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["isCustomer"] = this.isCustomer !== undefined ? this.isCustomer : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["affiliation"] = this.affiliation ? this.affiliation.toJSON() : null as any;
        data["hasAvatar"] = this.hasAvatar !== undefined ? this.hasAvatar : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        data["isSuperAdmin"] = this.isSuperAdmin !== undefined ? this.isSuperAdmin : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["showReasons"] = this.showReasons !== undefined ? this.showReasons : null as any;
        if (Array.isArray(this.accessTypes)) {
            data["accessTypes"] = [];
            for (let item of this.accessTypes)
                data["accessTypes"].push(item);
        }
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item);
        }
        data["socialProfiles"] = this.socialProfiles ? this.socialProfiles.toJSON() : null as any;
        return data;
    }
}

export interface IApiMember {
    id?: number;
    fullName?: string | null;
    organizations?: string[] | null;
    email?: string | null;
    phone?: string | null;
    isCustomer?: boolean;
    isNew?: boolean;
    countryId?: string | null;
    affiliation?: ApiMemberAddressDetails | null;
    hasAvatar?: boolean;
    createdDateTime?: Date;
    isSuperAdmin?: boolean;
    title?: string | null;
    status?: ApiMemberAccountStatusEnum;
    roles?: string[] | null;
    showReasons?: boolean;
    accessTypes?: AccessTypeEnum[] | null;
    activity?: ApiMemberActivity | null;
    socialNetworks?: SocialNetworkEnum[] | null;
    socialProfiles?: ApiMemberSocialProfiles | null;
}

export class ApiMemberActivity extends ApiAccountActivity implements IApiMemberActivity {
    lastLoginDate?: Date | null;
    loginCount?: number;

    constructor(data?: IApiMemberActivity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : null as any;
            this.loginCount = _data["loginCount"] !== undefined ? _data["loginCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : null as any;
        data["loginCount"] = this.loginCount !== undefined ? this.loginCount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiMemberActivity extends IApiAccountActivity {
    lastLoginDate?: Date | null;
    loginCount?: number;
}

export class ApiMemberSocialProfiles implements IApiMemberSocialProfiles {
    researchGateUrl?: string | null;
    scopusUrl?: string | null;

    constructor(data?: IApiMemberSocialProfiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.researchGateUrl = _data["researchGateUrl"] !== undefined ? _data["researchGateUrl"] : null as any;
            this.scopusUrl = _data["scopusUrl"] !== undefined ? _data["scopusUrl"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberSocialProfiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberSocialProfiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["researchGateUrl"] = this.researchGateUrl !== undefined ? this.researchGateUrl : null as any;
        data["scopusUrl"] = this.scopusUrl !== undefined ? this.scopusUrl : null as any;
        return data;
    }
}

export interface IApiMemberSocialProfiles {
    researchGateUrl?: string | null;
    scopusUrl?: string | null;
}

export class ApiMemberDetails implements IApiMemberDetails {
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    primaryEmail?: string | null;
    phone?: string | null;
    orcidId?: string | null;
    dateOfBirth?: Date | null;
    gender?: Gender | null;
    researchGate?: string | null;
    isOrganization?: boolean;
    university?: string | null;
    subscriber?: boolean;
    isCasaEnabled?: boolean;
    canSeeTitleNameForVolume?: boolean;
    noMailing?: boolean;
    memo?: string | null;

    constructor(data?: IApiMemberDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.primaryEmail = _data["primaryEmail"] !== undefined ? _data["primaryEmail"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.researchGate = _data["researchGate"] !== undefined ? _data["researchGate"] : null as any;
            this.isOrganization = _data["isOrganization"] !== undefined ? _data["isOrganization"] : null as any;
            this.university = _data["university"] !== undefined ? _data["university"] : null as any;
            this.subscriber = _data["subscriber"] !== undefined ? _data["subscriber"] : null as any;
            this.isCasaEnabled = _data["isCasaEnabled"] !== undefined ? _data["isCasaEnabled"] : null as any;
            this.canSeeTitleNameForVolume = _data["canSeeTitleNameForVolume"] !== undefined ? _data["canSeeTitleNameForVolume"] : null as any;
            this.noMailing = _data["noMailing"] !== undefined ? _data["noMailing"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["primaryEmail"] = this.primaryEmail !== undefined ? this.primaryEmail : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["researchGate"] = this.researchGate !== undefined ? this.researchGate : null as any;
        data["isOrganization"] = this.isOrganization !== undefined ? this.isOrganization : null as any;
        data["university"] = this.university !== undefined ? this.university : null as any;
        data["subscriber"] = this.subscriber !== undefined ? this.subscriber : null as any;
        data["isCasaEnabled"] = this.isCasaEnabled !== undefined ? this.isCasaEnabled : null as any;
        data["canSeeTitleNameForVolume"] = this.canSeeTitleNameForVolume !== undefined ? this.canSeeTitleNameForVolume : null as any;
        data["noMailing"] = this.noMailing !== undefined ? this.noMailing : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        return data;
    }
}

export interface IApiMemberDetails {
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    primaryEmail?: string | null;
    phone?: string | null;
    orcidId?: string | null;
    dateOfBirth?: Date | null;
    gender?: Gender | null;
    researchGate?: string | null;
    isOrganization?: boolean;
    university?: string | null;
    subscriber?: boolean;
    isCasaEnabled?: boolean;
    canSeeTitleNameForVolume?: boolean;
    noMailing?: boolean;
    memo?: string | null;
}

export class ApiPageResultOfApiOrganizationMembershipListItem implements IApiPageResultOfApiOrganizationMembershipListItem {
    items?: ApiOrganizationMembershipListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiOrganizationMembershipListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiOrganizationMembershipListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiOrganizationMembershipListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiOrganizationMembershipListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiOrganizationMembershipListItem {
    items?: ApiOrganizationMembershipListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiOrganizationMembershipListItem implements IApiOrganizationMembershipListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiShortOrganizationInfo)
    shortOrganizationDetails?: ApiShortOrganizationInfo | null;
    @columnMap(() => ApiOrganizationAccountStatusEnum)
    organizationStatus?: ApiOrganizationAccountStatusEnum;
    @columnMap(() => Number)
    relatedMembersCount?: number;
    @columnMap(() => OrganizationRelatedMemberTypeEnum)
    contactType?: OrganizationRelatedMemberTypeEnum;
    @columnMap(() => OrganizationRelatedMemberStatusEnum)
    connectionStatus?: OrganizationRelatedMemberStatusEnum;
    @columnMap(() => Date)
    added?: Date;

    constructor(data?: IApiOrganizationMembershipListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.shortOrganizationDetails = _data["shortOrganizationDetails"] ? ApiShortOrganizationInfo.fromJS(_data["shortOrganizationDetails"]) : null as any;
            this.organizationStatus = _data["organizationStatus"] !== undefined ? _data["organizationStatus"] : null as any;
            this.relatedMembersCount = _data["relatedMembersCount"] !== undefined ? _data["relatedMembersCount"] : null as any;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : null as any;
            this.connectionStatus = _data["connectionStatus"] !== undefined ? _data["connectionStatus"] : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiOrganizationMembershipListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOrganizationMembershipListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["shortOrganizationDetails"] = this.shortOrganizationDetails ? this.shortOrganizationDetails.toJSON() : null as any;
        data["organizationStatus"] = this.organizationStatus !== undefined ? this.organizationStatus : null as any;
        data["relatedMembersCount"] = this.relatedMembersCount !== undefined ? this.relatedMembersCount : null as any;
        data["contactType"] = this.contactType !== undefined ? this.contactType : null as any;
        data["connectionStatus"] = this.connectionStatus !== undefined ? this.connectionStatus : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        return data;
    }
}

export interface IApiOrganizationMembershipListItem {
    id?: number;
    shortOrganizationDetails?: ApiShortOrganizationInfo | null;
    organizationStatus?: ApiOrganizationAccountStatusEnum;
    relatedMembersCount?: number;
    contactType?: OrganizationRelatedMemberTypeEnum;
    connectionStatus?: OrganizationRelatedMemberStatusEnum;
    added?: Date;
}

export class ApiPageResultOfApiAuthorEmailListItem implements IApiPageResultOfApiAuthorEmailListItem {
    items?: ApiAuthorEmailListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiAuthorEmailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiAuthorEmailListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiAuthorEmailListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiAuthorEmailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiAuthorEmailListItem {
    items?: ApiAuthorEmailListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiAuthorEmailListItem implements IApiAuthorEmailListItem {
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => Number)
    @keyMap()
    paper?: number;
    @columnMap(() => String)
    isbnPrint?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    titleId?: number;

    constructor(data?: IApiAuthorEmailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.paper = _data["paper"] !== undefined ? _data["paper"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorEmailListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorEmailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["paper"] = this.paper !== undefined ? this.paper : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        return data;
    }
}

export interface IApiAuthorEmailListItem {
    email?: string | null;
    paper?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    titleId?: number;
}

export class ApiMemberAccountMembership implements IApiMemberAccountMembership {
    memberId?: number;
    organizationsCount?: number | null;
    consumersCount?: number | null;
    groupsCount?: number | null;

    constructor(data?: IApiMemberAccountMembership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.organizationsCount = _data["organizationsCount"] !== undefined ? _data["organizationsCount"] : null as any;
            this.consumersCount = _data["consumersCount"] !== undefined ? _data["consumersCount"] : null as any;
            this.groupsCount = _data["groupsCount"] !== undefined ? _data["groupsCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberAccountMembership {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberAccountMembership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["organizationsCount"] = this.organizationsCount !== undefined ? this.organizationsCount : null as any;
        data["consumersCount"] = this.consumersCount !== undefined ? this.consumersCount : null as any;
        data["groupsCount"] = this.groupsCount !== undefined ? this.groupsCount : null as any;
        return data;
    }
}

export interface IApiMemberAccountMembership {
    memberId?: number;
    organizationsCount?: number | null;
    consumersCount?: number | null;
    groupsCount?: number | null;
}

export class ApiPageResultOfApiJournalResponsibilityListItem implements IApiPageResultOfApiJournalResponsibilityListItem {
    items?: ApiJournalResponsibilityListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiJournalResponsibilityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiJournalResponsibilityListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiJournalResponsibilityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiJournalResponsibilityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiJournalResponsibilityListItem {
    items?: ApiJournalResponsibilityListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiJournalResponsibilityListItem implements IApiJournalResponsibilityListItem {
    @keyMap()
    key?: string | null;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => ApiNamedListItem)
    responsibilities?: ApiNamedListItem | null;
    @columnMap(() => ApiNamedListItem)
    createdBy?: ApiNamedListItem | null;
    @columnMap(() => Date)
    dateAdded?: Date;
    responsibilityPos?: number;
    journalId?: number;

    constructor(data?: IApiJournalResponsibilityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.responsibilities = _data["responsibilities"] ? ApiNamedListItem.fromJS(_data["responsibilities"]) : null as any;
            this.createdBy = _data["createdBy"] ? ApiNamedListItem.fromJS(_data["createdBy"]) : null as any;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : null as any;
            this.responsibilityPos = _data["responsibilityPos"] !== undefined ? _data["responsibilityPos"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalResponsibilityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalResponsibilityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["responsibilities"] = this.responsibilities ? this.responsibilities.toJSON() : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        data["responsibilityPos"] = this.responsibilityPos !== undefined ? this.responsibilityPos : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        return data;
    }
}

export interface IApiJournalResponsibilityListItem {
    key?: string | null;
    kurzel?: string | null;
    responsibilities?: ApiNamedListItem | null;
    createdBy?: ApiNamedListItem | null;
    dateAdded?: Date;
    responsibilityPos?: number;
    journalId?: number;
}

export class ApiJournalResponsibilities implements IApiJournalResponsibilities {
    responsibilityIdList?: number[] | null;
    journalIdList?: number[] | null;

    constructor(data?: IApiJournalResponsibilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responsibilityIdList"])) {
                this.responsibilityIdList = [] as any;
                for (let item of _data["responsibilityIdList"])
                    this.responsibilityIdList!.push(item);
            }
            else {
                this.responsibilityIdList = null as any;
            }
            if (Array.isArray(_data["journalIdList"])) {
                this.journalIdList = [] as any;
                for (let item of _data["journalIdList"])
                    this.journalIdList!.push(item);
            }
            else {
                this.journalIdList = null as any;
            }
        }
    }

    static fromJS(data: any): ApiJournalResponsibilities {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalResponsibilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responsibilityIdList)) {
            data["responsibilityIdList"] = [];
            for (let item of this.responsibilityIdList)
                data["responsibilityIdList"].push(item);
        }
        if (Array.isArray(this.journalIdList)) {
            data["journalIdList"] = [];
            for (let item of this.journalIdList)
                data["journalIdList"].push(item);
        }
        return data;
    }
}

export interface IApiJournalResponsibilities {
    responsibilityIdList?: number[] | null;
    journalIdList?: number[] | null;
}

export class ApiJournalResponsibility implements IApiJournalResponsibility {
    responsibilityId: number;
    journalId: number;

    constructor(data?: IApiJournalResponsibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsibilityId = _data["responsibilityId"] !== undefined ? _data["responsibilityId"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalResponsibility {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalResponsibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsibilityId"] = this.responsibilityId !== undefined ? this.responsibilityId : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        return data;
    }
}

export interface IApiJournalResponsibility {
    responsibilityId: number;
    journalId: number;
}

export class ApiPageResultOfApiMemberGroupListItem implements IApiPageResultOfApiMemberGroupListItem {
    items?: ApiMemberGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiMemberGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiMemberGroupListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiMemberGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiMemberGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiMemberGroupListItem {
    items?: ApiMemberGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiMemberGroupListItem implements IApiMemberGroupListItem {
    @columnMap(() => Number)
    @keyMap()
    groupId?: number;
    @columnMap(() => String)
    groupName?: string | null;
    @columnMap(() => ApiGroupTypeEnum, true)
    groupType?: ApiGroupTypeEnum[] | null;
    @columnMap(() => GroupStatusEnum)
    groupStatus?: GroupStatusEnum;
    @columnMap(() => Boolean)
    isAdmin?: boolean;
    @columnMap(() => AccessTypeEnum, true)
    accessTo?: AccessTypeEnum[] | null;
    @columnMap(() => Date)
    dateAdded?: Date;

    constructor(data?: IApiMemberGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            if (Array.isArray(_data["groupType"])) {
                this.groupType = [] as any;
                for (let item of _data["groupType"])
                    this.groupType!.push(item);
            }
            else {
                this.groupType = null as any;
            }
            this.groupStatus = _data["groupStatus"] !== undefined ? _data["groupStatus"] : null as any;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : null as any;
            if (Array.isArray(_data["accessTo"])) {
                this.accessTo = [] as any;
                for (let item of _data["accessTo"])
                    this.accessTo!.push(item);
            }
            else {
                this.accessTo = null as any;
            }
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiMemberGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        if (Array.isArray(this.groupType)) {
            data["groupType"] = [];
            for (let item of this.groupType)
                data["groupType"].push(item);
        }
        data["groupStatus"] = this.groupStatus !== undefined ? this.groupStatus : null as any;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null as any;
        if (Array.isArray(this.accessTo)) {
            data["accessTo"] = [];
            for (let item of this.accessTo)
                data["accessTo"].push(item);
        }
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        return data;
    }
}

export interface IApiMemberGroupListItem {
    groupId?: number;
    groupName?: string | null;
    groupType?: ApiGroupTypeEnum[] | null;
    groupStatus?: GroupStatusEnum;
    isAdmin?: boolean;
    accessTo?: AccessTypeEnum[] | null;
    dateAdded?: Date;
}

export class ApiPageResultOfApiGroupMemberListItem implements IApiPageResultOfApiGroupMemberListItem {
    items?: ApiGroupMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiGroupMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiGroupMemberListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiGroupMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiGroupMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiGroupMemberListItem {
    items?: ApiGroupMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiGroupMemberListItem implements IApiGroupMemberListItem {
    @columnMap(() => Number)
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    @columnMap(() => ApiMemberAccountStatusEnum)
    memberStatus?: ApiMemberAccountStatusEnum;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => Boolean)
    isAdmin?: boolean;
    @columnMap(() => Date)
    dateAdded?: Date;

    constructor(data?: IApiGroupMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : null as any;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiGroupMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null as any;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        return data;
    }
}

export interface IApiGroupMemberListItem {
    memberId?: number;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    memberStatus?: ApiMemberAccountStatusEnum;
    email?: string | null;
    isAdmin?: boolean;
    dateAdded?: Date;
}

export class ApiPageResultOfApiGroupAdminListItem implements IApiPageResultOfApiGroupAdminListItem {
    items?: ApiGroupAdminListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiGroupAdminListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiGroupAdminListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiGroupAdminListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiGroupAdminListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiGroupAdminListItem {
    items?: ApiGroupAdminListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiGroupAdminListItem implements IApiGroupAdminListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => ApiMemberInfo)
    member?: ApiMemberInfo | null;

    constructor(data?: IApiGroupAdminListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.member = _data["member"] ? ApiMemberInfo.fromJS(_data["member"]) : null as any;
        }
    }

    static fromJS(data: any): ApiGroupAdminListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupAdminListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["member"] = this.member ? this.member.toJSON() : null as any;
        return data;
    }
}

export interface IApiGroupAdminListItem {
    memberId?: number;
    member?: ApiMemberInfo | null;
}

export class ApiGroupAdminInfo implements IApiGroupAdminInfo {
    welcomeMessageEnabled?: boolean;
    welcomeMessage?: string | null;

    constructor(data?: IApiGroupAdminInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.welcomeMessageEnabled = _data["welcomeMessageEnabled"] !== undefined ? _data["welcomeMessageEnabled"] : null as any;
            this.welcomeMessage = _data["welcomeMessage"] !== undefined ? _data["welcomeMessage"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupAdminInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupAdminInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["welcomeMessageEnabled"] = this.welcomeMessageEnabled !== undefined ? this.welcomeMessageEnabled : null as any;
        data["welcomeMessage"] = this.welcomeMessage !== undefined ? this.welcomeMessage : null as any;
        return data;
    }
}

export interface IApiGroupAdminInfo {
    welcomeMessageEnabled?: boolean;
    welcomeMessage?: string | null;
}

export class ApiPageResultOfApiGroupOrganizationListItem implements IApiPageResultOfApiGroupOrganizationListItem {
    items?: ApiGroupOrganizationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiGroupOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiGroupOrganizationListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiGroupOrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiGroupOrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiGroupOrganizationListItem {
    items?: ApiGroupOrganizationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiGroupOrganizationListItem implements IApiGroupOrganizationListItem {
    @columnMap(() => Number)
    @keyMap()
    organizationId?: number;
    @columnMap(() => String)
    organizationName?: string | null;
    @columnMap(() => OrganizationTypeEnum)
    organizationType?: OrganizationTypeEnum;
    @columnMap(() => ApiOrganizationAccountStatusEnum)
    organizationStatus?: ApiOrganizationAccountStatusEnum;
    @columnMap(() => Date)
    dateAdded?: Date;

    constructor(data?: IApiGroupOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : null as any;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : null as any;
            this.organizationType = _data["organizationType"] !== undefined ? _data["organizationType"] : null as any;
            this.organizationStatus = _data["organizationStatus"] !== undefined ? _data["organizationStatus"] : null as any;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiGroupOrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupOrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : null as any;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : null as any;
        data["organizationType"] = this.organizationType !== undefined ? this.organizationType : null as any;
        data["organizationStatus"] = this.organizationStatus !== undefined ? this.organizationStatus : null as any;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        return data;
    }
}

export interface IApiGroupOrganizationListItem {
    organizationId?: number;
    organizationName?: string | null;
    organizationType?: OrganizationTypeEnum;
    organizationStatus?: ApiOrganizationAccountStatusEnum;
    dateAdded?: Date;
}

export class ApiGroup implements IApiGroup {
    id?: number;
    name: string;
    description?: string | null;
    hasMembers?: boolean;
    hasOrganizations?: boolean;
    isRemovable?: boolean;
    status?: GroupStatusEnum;
    groupType?: ApiGroupTypeEnum[] | null;
    accessTo?: ApiGroupAccessTypeEnum[] | null;
    showReasons?: boolean;

    constructor(data?: IApiGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.hasMembers = _data["hasMembers"] !== undefined ? _data["hasMembers"] : null as any;
            this.hasOrganizations = _data["hasOrganizations"] !== undefined ? _data["hasOrganizations"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["groupType"])) {
                this.groupType = [] as any;
                for (let item of _data["groupType"])
                    this.groupType!.push(item);
            }
            else {
                this.groupType = null as any;
            }
            if (Array.isArray(_data["accessTo"])) {
                this.accessTo = [] as any;
                for (let item of _data["accessTo"])
                    this.accessTo!.push(item);
            }
            else {
                this.accessTo = null as any;
            }
            this.showReasons = _data["showReasons"] !== undefined ? _data["showReasons"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["hasMembers"] = this.hasMembers !== undefined ? this.hasMembers : null as any;
        data["hasOrganizations"] = this.hasOrganizations !== undefined ? this.hasOrganizations : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.groupType)) {
            data["groupType"] = [];
            for (let item of this.groupType)
                data["groupType"].push(item);
        }
        if (Array.isArray(this.accessTo)) {
            data["accessTo"] = [];
            for (let item of this.accessTo)
                data["accessTo"].push(item);
        }
        data["showReasons"] = this.showReasons !== undefined ? this.showReasons : null as any;
        return data;
    }
}

export interface IApiGroup {
    id?: number;
    name: string;
    description?: string | null;
    hasMembers?: boolean;
    hasOrganizations?: boolean;
    isRemovable?: boolean;
    status?: GroupStatusEnum;
    groupType?: ApiGroupTypeEnum[] | null;
    accessTo?: ApiGroupAccessTypeEnum[] | null;
    showReasons?: boolean;
}

export enum ApiGroupAccessTypeEnum {
    PWeBooks = 0,
    PWPapers = 1,
    IPPapers = 2,
    IPeBooks = 3,
    IPPapersTrial = 4,
    IPeBooksTrial = 5,
}

export class ApiPageResultOfApiGroupListItem implements IApiPageResultOfApiGroupListItem {
    items?: ApiGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiGroupListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiGroupListItem {
    items?: ApiGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiGroupListItem implements IApiGroupListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => String)
    description?: string | null;
    @columnMap(() => GroupStatusEnum)
    status?: GroupStatusEnum;
    @columnMap(() => ApiMemberInfo, true)
    admins?: ApiMemberInfo[] | null;
    @columnMap(() => Number)
    membersCount?: number;
    @columnMap(() => Number)
    organizationsCount?: number;

    constructor(data?: IApiGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                this.admins = null as any;
            }
            this.membersCount = _data["membersCount"] !== undefined ? _data["membersCount"] : null as any;
            this.organizationsCount = _data["organizationsCount"] !== undefined ? _data["organizationsCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item ? item.toJSON() : null as any);
        }
        data["membersCount"] = this.membersCount !== undefined ? this.membersCount : null as any;
        data["organizationsCount"] = this.organizationsCount !== undefined ? this.organizationsCount : null as any;
        return data;
    }
}

export interface IApiGroupListItem {
    id?: number;
    name?: string | null;
    description?: string | null;
    status?: GroupStatusEnum;
    admins?: ApiMemberInfo[] | null;
    membersCount?: number;
    organizationsCount?: number;
}

export class ApiGroupAddMembersRequest implements IApiGroupAddMembersRequest {
    groupIds?: number[] | null;
    isAdmin?: boolean;

    constructor(data?: IApiGroupAddMembersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            else {
                this.groupIds = null as any;
            }
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupAddMembersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupAddMembersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null as any;
        return data;
    }
}

export interface IApiGroupAddMembersRequest {
    groupIds?: number[] | null;
    isAdmin?: boolean;
}

export class ApiGroupAddOrganizationsRequest implements IApiGroupAddOrganizationsRequest {
    groupIds?: number[] | null;

    constructor(data?: IApiGroupAddOrganizationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            else {
                this.groupIds = null as any;
            }
        }
    }

    static fromJS(data: any): ApiGroupAddOrganizationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupAddOrganizationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        return data;
    }
}

export interface IApiGroupAddOrganizationsRequest {
    groupIds?: number[] | null;
}

export class ApiGroupActivity extends ApiAccountActivity implements IApiGroupActivity {
    creatorId?: number;
    creatorFullName?: string | null;

    constructor(data?: IApiGroupActivity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiGroupActivity extends IApiAccountActivity {
    creatorId?: number;
    creatorFullName?: string | null;
}

export class ApiGroupDetails implements IApiGroupDetails {
    name?: string | null;
    description?: string | null;

    constructor(data?: IApiGroupDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApiGroupDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IApiGroupDetails {
    name?: string | null;
    description?: string | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(() => result);
    else
        return _observableThrow(() => new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<any> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            if (typeof window === 'undefined') {
                observer.next(blob);
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        }
    });
}

/* tslint:disable */
/* eslint-disable */